<template>
	<div id="swp-main-container" class="develop-cards">
		<div
			style="
        position: fixed;
        top: 70px;
        z-index: 10;
        backdrop-filter: blur(2px);
      "
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="page-heading d-flex align-items-center justify-content-between">
			<div class="d-flex justify-content-between align-items-center">
				<div class="d-flex">
					<img
						src="../../assets/icons/Reports/bckarrow.svg"
						alt=""
						class="pointer"
						@click="goTobackpage()"
					/>
				</div>
				<div class="main-head ml-3">
					<span>Share With People</span>
				</div>
			</div>
			<div
				class="swp-warning-box mr-3"
				:style="selectedGroupDel.length > 0 ? '' : ''"
				v-if="!evaluatorTagged"
			>
				<img src="../../assets/icons/Qpbuilder/warning.svg" alt="" />
				Please ensure that evaluators are assigned for the manual assessment of
				questions that are not auto-evaluated in both individual and group
				tests.
			</div>

			<div class="d-flex justify-content-end align-items-center relativeclass">
				<div
					v-if="selectedGroupDel.length > 0"
					class="pl-3 pr-3 pt-1 pb-1 qb-sel-questions mr-2 d-flex align-items-center"
				>
					<span v-if="candidateType == 'I'">
						Selected Individual's: {{ selectedGroupDel.length }}</span
					>
					<span v-else> Selected Group's: {{ selectedGroupDel.length }} </span>
				</div>
			</div>
		</div>
		<div class="d-flex" style="overflow-x: auto">
			<div class="shareWithPeople-table-container relativeclass mt-2 m-2">
				<div class="d-flex align-items-end justify-content-between">
					<div class="d-flex align-items-center mb-0">
						<div
							v-if="roles.includes(roledata.getIndividual)"
							class="position-relative d-flex align-items-center grp-mr pointer"
							@click="openIndividual()"
						>
							<div
								:class="openInd ? 'grp-tab-sel' : 'grp-tab'"
								class="d-flex align-items-center justify-content-center"
							>
								Individual
							</div>
							<div :class="openInd ? 'grp-slant-sel' : 'grp-slant'"></div>
						</div>
						<div
							v-if="roles.includes(roledata.getGroup)"
							@click="openGroup()"
							class="position-relative d-flex align-items-center grp-mr pointer"
						>
							<div
								:class="openGrp ? 'grp-tab-sel' : 'grp-tab'"
								class="d-flex align-items-center justify-content-center"
							>
								Group
							</div>
							<div
								:class="openGrp ? 'grp-slant-sel' : 'grp-slant'"
								class="grp-slant"
							></div>
						</div>
						<div
							v-if="roles.includes(roledata.getGroup)"
							@click="openRecruitement()"
							class="position-relative d-flex align-items-center pointer"
						>
							<div
								:class="openRec ? 'grp-tab-sel' : 'grp-tab'"
								class="d-flex align-items-center justify-content-center"
							>
								Recruitment group
							</div>
							<div
								:class="openRec ? 'grp-slant-sel' : 'grp-slant'"
								class="grp-slant"
							></div>
						</div>
					</div>
					<div class="pb-2">
						<b-button
							class="addbtn"
							@click="addIndividual()"
							v-if="roles.includes(roledata.addIndividual) && openInd"
						>
							<img
								src="../../assets/icons/Reports/addIndividual.svg"
								alt=""
								class="mr-2 mb-1"
							/>
							<span class="">Add Individual</span>
						</b-button>
						<b-button
							class="addbtn pl-4 pr-4"
							@click="opengrpcontainer"
							v-if="roles.includes(roledata.addGroup) && openGrp"
						>
							<img
								src="../../assets/sharegroupicon.svg"
								alt=""
								class="mr-2 mb-1"
							/>
							<span class="">Add Group</span>
						</b-button>
						<div v-if="openRec" style="padding: 21px"></div>
					</div>
				</div>

				<!-- table new design starts from here -->
				<div class="shareWithPeople-main-table">
					<div class="shareWithPeople-table-head">
						<div
							style="width: 3%"
							class="pl-2"
							v-if="roles.includes(roledata.tagevaluator) || deleteAccess"
						>
							<span
								class="text-center qb-header-checkbox"
								v-if="groups.length !== 0"
							>
								<b-form-checkbox
									:disabled="candidateType == 'R'"
									v-model="selectall"
									@change="selectAll()"
								>
								</b-form-checkbox>
							</span>
						</div>
						<div style="width: 5%" class="text-center">Type</div>
						<div class="text-center pl-3" style="width: 14%">
							<span>
								<span v-if="candidateType == 'I'">Email</span>
								<span v-else>Group Name</span>
								<template v-if="sortColumn == 'groupName'">
									<img
										@click="sort('groupName'), (sorting = !sorting)"
										v-if="sorting == true"
										src="../../assets/sort - down.svg"
										alt=""
										class="pointer"
									/>
									<img
										v-else
										@click="sort('groupName'), (sorting = !sorting)"
										src="../../assets/sort - up.svg"
										alt=""
										class="pointer"
									/>
								</template>
								<img
									v-else
									@click="sort('groupName'), (sorting = !sorting)"
									src="../../assets/sort -none.svg"
									alt=""
									class="pointer"
								/>
							</span>
						</div>
						<div class="text-center" style="width: 33%">
							<span> Link </span>
						</div>
						<div class="text-center" style="width: 10%">
							<span> Share Link </span>
						</div>
						<div class="text-center" style="width: 10%">
							<span> Price Information </span>
						</div>
						<div class="text-center" style="width: 10%">
							<span> Use Previous Link </span>
						</div>
						<div class="text-center" style="width: 5%">
							<span v-if="roles.includes(roledata.getconfig)"> Configure </span>
						</div>
						<div class="text-center" style="width: 10%">
							<div
								class="d-flex align-items-center ml-3 justify-content-center"
							>
								<div class="d-flex position-relative">
									<img
										ref="rec"
										v-b-popover.hover.top="'Filter'"
										src="../../assets/icons/uploadexcel/swpfilter.svg"
										alt=""
										class="pointer ml-4"
										@click="modalpop()"
									/>
									<div
										class="qb-filter-count position-absolute"
										v-if="filtercount != 0"
										style="right: -12px;top: -5px;"
									>
										{{ filtercount }}
									</div>
								</div>

								<div class="ml-3" v-if="groups.length !== 0 && deleteAccess">
									<b-button
										variant="outline"
										class="qb-remove-padding ml-1"
										:disabled="selectedGroupDel.length == 0"
										v-b-modal.modal-delete
										><img
											v-b-tooltip.hover="{ variant: 'secondary' }"
											:title="
												candidateType == 'R'
													? 'cannot delete recruitment group'
													: 'Delete'
											"
											class="pointer"
											src="../../assets/icons/access-delete.svg"
											alt=""
										/>
									</b-button>
								</div>
								<div v-else style="width: 28px"></div>
							</div>
						</div>
					</div>
					<div class="shareWithPeople-table-body p-1">
						<template v-if="groups.length == 0 && searchTopicTest != ''">
							<div
								class="d-flex flex-column justify-content-center align-items-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<span v-if="candidateType == 'I'" class="searchnotfound"
									>No results found for
									<span class="searchtext"> "{{ searchTopicTest }}" </span>
									individual searched</span
								>
								<span v-else class="searchnotfound"
									>No results found for
									<span class="searchtext"> "{{ searchTopicTest }}" </span>
									group searched</span
								>
							</div>
						</template>
						<template v-else-if="groups.length == 0 && filtercount != 0">
							<div
								class="d-flex flex-column justify-content-center align-items-center h-100"
							>
								<div>
									<img src="../../assets/searchnotfound.svg" alt="" />
								</div>
								<span class="searchnotfound">No data found </span>
							</div>
						</template>

						<template
							v-else-if="
								groups.length == 0 && searchTopicTest == '' && filtercount == 0
							"
						>
							<div
								class="d-flex flex-column justify-content-center align-items-center h-100"
							>
								<div>
									<img src="../../assets/icons/share/nogroupimg.svg" alt="" />
								</div>
								<span v-if="candidateType == 'I'" class="searchnotfound mt-2"
									>To add individual email address and share the test link,
									click on "Add Individual" button.</span
								>
								<span
									v-else-if="candidateType == 'G'"
									class="searchnotfound mt-2"
									>To either create a new group or choose an existing one and
									share the test link, simply click on the "Add Group" button.
								</span>
								<span v-else class="searchnotfound mt-2">
									Groups created from the recruitment process are visible here.
								</span>
							</div>
						</template>

						<template v-else>
							<div
								v-for="(group, i) in groups"
								:key="i"
								:class="
									group.groupID == selectedGroup.groupID ||
									selectedGroupDel.includes(group.groupID)
										? 'shareWithPeople-changecolor-row'
										: 'shareWithPeople-table-row'
								"
								:id="group.groupID"
							>
								<div
									style="width: 3%"
									class="text-center"
									v-if="roles.includes(roledata.tagevaluator) || deleteAccess"
								>
									<b-form-checkbox
										:disabled="group.candidateType == 'R'"
										v-model="selectedGroupDel"
										@change="deselect()"
										:value="group.groupID"
									>
									</b-form-checkbox>
								</div>
								<div style="width: 4%" class="text-center">
									<span v-if="group.candidateType == 'I'"
										><img
											:id="'private-popover' + i"
											src="../../assets/icons/Reports/singlepep.svg"
											alt=""
									/></span>
									<span v-if="group.candidateType == 'G'"
										><img
											:id="'private-popover' + i"
											src="../../assets/icons/Reports/grouppeople.svg"
											alt=""
									/></span>
									<span v-if="group.candidateType == 'R'"
										><img
											:id="'private-popover' + i"
											src="../../assets/icons/share/recruitmentGroup.svg"
											alt=""
									/></span>
									<b-popover
										:target="'private-popover' + i"
										triggers="hover"
										placement="top"
									>
										<div
											class="d-flex justify-content-center"
											:class="group.candidateType == 'R' ? 'swp-main-text' : ''"
										>
											{{ group.candidateType == "I" ? "Individual" : "Group" }}
										</div>
										<div
											v-if="group.candidateType == 'R'"
											class="pr-tp-testhead"
										>
											Created from recruitment
										</div>
									</b-popover>
								</div>
								<div style="width: 15%" class="text-center">
									<div
										v-b-popover.hover.top="`${group.groupName}`"
										style="max-width: 100%"
										class="d-inline-block d-flex align-items-center justify-content-center pl-4"
									>
										<div class="text-truncate">{{ group.groupName }}</div>
									</div>
								</div>
								<div style="width: 33%" class="text-center pointer">
									<span
										class="d-flex align-items-center justify-content-center"
										v-if="group.shareLink == null"
										@click="
											group.candidateType == 'R' ||
											group.configured == false ||
											group.open == 'False' ||
											(evaluatorTagged == false && group.evaluator.length == 0)
												? ''
												: linkconfirmmodal(group)
										"
										v-b-tooltip.hover="{ variant: 'secondary' }"
										:title="
											group.candidateType == 'R'
												? 'Cannot generate link for recruitement group'
												: evaluatorTagged == false &&
												  group.evaluator.length == 0
												? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
												: group.configured == false
												? 'Tag Configuration To Generate Link'
												: group.open == 'False'
												? 'Tag Active Configuration To Generate Link'
												: ''
										"
									>
										<span>
											<img
												src="../../assets/icons/Reports/disableupdate.svg"
												alt=""
												v-if="
													group.candidateType == 'R' ||
														group.configured == false ||
														group.open == 'False' ||
														(evaluatorTagged == false &&
															group.evaluator.length == 0)
												"
											/>
											<img
												v-else
												src="../../assets/icons/Reports/enableupdate.svg"
												alt=""
											/>
										</span>
										<span
											:class="
												group.candidateType == 'R' ||
												group.configured == false ||
												group.open == 'False' ||
												(evaluatorTagged == false &&
													group.evaluator.length == 0)
													? 'disablesharetext'
													: ''
											"
											>Generate Link</span
										>
									</span>
									<div
										v-else
										class="d-flex align-items-center justify-content-center"
									>
										<div style="width: 70%">
											<div class="swp-linkBackground d-flex align-items-center">
												<div style="width: 92%">
													<b-form-input
														style="border: none"
														:id="'shrelink' + group.groupID"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														:title="
															group.candidateType == 'R'
																? 'Cannot generate link for recruitement group'
																: evaluatorTagged == false &&
																  group.evaluator.length == 0
																? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
																: group.open == 'False'
																? 'Tag Active Configuration'
																: group.shareLink
														"
														class="mr-5 w-100"
														:class="
															group.candidateType == 'R' ||
															(evaluatorTagged == false &&
																group.evaluator.length == 0) ||
															group.open == 'False'
																? 'disableLinkInput'
																: grpcontainer == false
																? 'sharelink-elipsis'
																: 'sharelink-elipsis-show'
														"
														v-model="group.shareLink"
														:disabled="
															group.candidateType == 'R' ||
																(evaluatorTagged == false &&
																	group.evaluator.length == 0)
														"
														readonly
													>
													</b-form-input>
												</div>
												<div
													style="width: 8%; margin-bottom: 3px"
													v-b-tooltip.hover="{ variant: 'secondary' }"
													:title="
														group.candidateType == 'R'
															? 'Cannot copy link for recruitement group'
															: evaluatorTagged == false &&
															  group.evaluator.length == 0
															? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Copy Link'
															: group.open == 'False'
															? ''
															: 'Copy'
													"
													class="mr-2 mt-1"
													id="copyBtn"
												>
													<img
														v-if="
															group.candidateType == 'R' ||
																(evaluatorTagged == false &&
																	group.evaluator.length == 0) ||
																group.open == 'False'
														"
														src="../../assets/icons/share/copyDisabled.svg"
														alt=""
													/>
													<img
														@click="
															group.candidateType == 'R' ||
															(evaluatorTagged == false &&
																group.evaluator.length == 0)
																? ''
																: copyToClipboard(group.groupID)
														"
														v-else
														src="../../assets/sharecopy.svg"
														alt=""
													/>
													<span
														:class="
															group.candidateType == 'R' ||
															(evaluatorTagged == false &&
																group.evaluator.length == 0) ||
															group.open == 'False'
																? 'disablesharetext'
																: ''
														"
													></span>
												</div>
											</div>
										</div>
										<div
											style="width: 30%; text-decoration: underline"
											v-b-tooltip.hover="{ variant: 'secondary' }"
											:title="
												group.candidateType == 'R'
													? 'Cannot update link for recruitement group'
													: evaluatorTagged == false &&
													  group.evaluator.length == 0
													? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Update Link'
													: group.open == 'False'
													? 'Tag Active Configuration To Update Link'
													: ''
											"
											:class="
												group.candidateType == 'R' ||
												(evaluatorTagged == false &&
													group.evaluator.length == 0) ||
												group.open == 'False'
													? 'disablesharetext'
													: ''
											"
											@click="
												group.candidateType == 'R' ||
												(evaluatorTagged == false &&
													group.evaluator.length == 0) ||
												group.open == 'False'
													? ''
													: ((updatelink = true), linkconfirmmodal(group))
											"
										>
											<img
												src="../../assets/icons/Reports/disableupdate.svg"
												alt=""
												v-if="
													group.candidateType == 'R' ||
														(evaluatorTagged == false &&
															group.evaluator.length == 0) ||
														group.open == 'False'
												"
											/><img
												v-else
												src="../../assets/icons/Reports/enableupdate.svg"
												alt=""
											/>Update Link
										</div>
									</div>
								</div>

								<div style="width: 10%" class="text-center pointer">
									<img
										v-if="
											group.candidateType == 'R' ||
												group.shareLink == null ||
												group.open == 'False' ||
												(evaluatorTagged == false &&
													group.evaluator.length == 0)
										"
										src="../../assets/icons/Reports/disableshareicon.svg"
										alt=""
										v-b-tooltip.hover="{ variant: 'secondary' }"
										:title="
											group.candidateType == 'R'
												? 'Cannot share link for recruitement group'
												: evaluatorTagged == false &&
												  group.evaluator.length == 0
												? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Share Link'
												: group.configured == false
												? 'Generate Link To Share'
												: group.open == 'False'
												? 'Tag Active Configuration To Share Link'
												: 'Generate Link To Share'
										"
									/>
									<span
										class="ml-2"
										v-b-popover.hover.top="'Share Link'"
										v-else-if="group.shareStatus == 'unshared'"
										@click="linkShareModal(group)"
									>
										<img
											class="mb-1"
											src="../../assets/icons/Reports/notshared.svg"
											alt=""
										/>
										<span class="swp-share-reshare-text"> Share </span>
									</span>
									<span v-else class="ml-2" @click="linkShareModal(group)">
										<img
											class="mb-1"
											src="../../assets/icons/Reports/sharedgreenicon.svg"
											alt=""
										/>
										<span
											v-b-popover.hover.top="'Resend Link'"
											class="swp-share-reshare-text ml-1"
											>Resend</span
										>
									</span>
								</div>
								<div
									style="width: 10%"
									class="text-center pointer position-relative tooltip-wrapper"
								>
									<section class="" v-if="group.setPricing">
										<span
											v-if="
												Number(group.listPrice) === Number(group.finalPrice)
											"
											class="right-container-subhead"
										>
											₹{{ group.finalPrice }}
										</span>
										<template v-else>
											<span
												style="font-family: 'Montserrat',sans-serif;font-weight: 400;font-size: 13px;text-decoration-line: line-through;color: #999999;"
											>
												Rs.{{ group.listPrice }}
											</span>

											<span class="right-container-subhead">
												₹{{ group.finalPrice }}
											</span>
										</template>
									</section>
									<section v-else>
										<img src="../../assets/icons/dash.svg" alt="" />
									</section>

									<!-- TOOLTIP -->
									<div class="price-tooltip" v-if="group.setPricing">
										<div class="tooltip-row">
											<span class="fw-500 fs-12 font-lato color-344054"
												>List Price</span
											>
											<span class="fw-500 fs-12 font-mont color-333333"
												>₹{{ group.listPrice }}</span
											>
										</div>

										<div class="tooltip-row">
											<span class="fw-500 fs-12 font-lato color-344054"
												>Discount</span
											>
											<span class="fw-500 fs-12 font-mont color-333333"
												>₹{{ group.discountAmount }}</span
											>
										</div>
										<div class="tooltip-row">
											<span class="fw-500 fs-12 font-lato color-344054"
												>Final Price</span
											>
											<span class="fw-500 fs-12 font-mont color-333333"
												>₹{{ group.finalPrice }}</span
											>
										</div>
										<div class="tooltip-row">
											<span class="fw-500 fs-12 font-lato color-344054 w-75"
												>Payment Gateway Charges</span
											>
											<span class="fw-500 fs-12 font-mont color-333333"
												>{{ gatewayPercent }}%</span
											>
										</div>
										<hr class="my-1" />
										<div class="tooltip-row total">
											<span class="fw-500 fs-12 font-lato color-333333 w-75"
												>Final Amount Receivable</span
											>
											<span class="fw-600 fs-12 font-mont color-333333"
												>₹{{
													group.finalPrice -
														(group.finalPrice * gatewayPercent) / 100
												}}</span
											>
										</div>
									</div>
								</div>

								<div
									style="width: 10%"
									class="text-center"
									v-if="
										group.candidateType == 'R' ||
											group.shareLink == null ||
											group.prevLinks.length <= 0
									"
								>
									<img src="../../assets/icons/dash.svg" alt="" />
								</div>
								<div style="width: 10%" class="text-center" v-else>
									<img
										v-if="group.open == 'False'"
										src="../../assets/icons/dash.svg"
										alt=""
									/>

									<label class="switch mt-2" v-else>
										<input
											type="checkbox"
											v-model="group.prevLinkStatus"
											@change="setPrevLinkStatus(group)"
										/>
										<span class="slider round"></span>
									</label>
								</div>
								<div
									style="width: 5%"
									class="text-center"
									:class="hideAfterFiveSecons ? 'pl-0' : 'pl-3'"
								>
									<span
										v-if="
											roles.includes(roledata.getconfig) &&
												group.configured == false &&
												group.showThisWhenFirstTime == true
										"
									>
										<div
											:class="
												hideAfterFiveSecons
													? 'mx-0 swp-addconfig-background w-100 text-center d-flex align-items-center justify-content-center'
													: ''
											"
											class="pt-2 pb-2 ml-4 mr-4 pointer"
											@click="goToConfigure(group)"
										>
											<img
												src="../../assets/icons/Reports/notConfigured.svg"
												alt=""
											/>
										</div>
										<div
											v-if="hideAfterFiveSecons"
											class="pointer"
											style="
                        position: absolute;
                        top: 56%;
                        right: 5%;
                        z-index: 1;
                      "
										>
											<img
												class="pointer"
												src="../../assets/addConfidTooltip.svg"
												alt=""
											/>
										</div>
									</span>
									<span
										v-else-if="
											roles.includes(roledata.getconfig) &&
												group.configured == false &&
												group.showThisWhenFirstTime == false
										"
									>
										<div
											class="pt-2 pb-2 ml-4 mr-4 pointer"
											@click="goToConfigure(group)"
										>
											<img
												v-b-popover.hover="'Add Configuration'"
												src="../../assets/icons/Reports/notConfigured.svg"
												alt=""
											/>
										</div>
									</span>
									<span v-else-if="roles.includes(roledata.getconfig)">
										<img
											class="pointer"
											v-b-popover.hover.top="'Update Configuration'"
											src="../../assets/icons/Reports/enableconfigicon.svg"
											alt=""
											@click="goToConfigure(group)"
										/>
									</span>
								</div>
								<div style="width: 10%" class="text-center">
									<img
										v-if="
											(group.candidateType === 'G' &&
												roles.includes(roledata.editGroup)) ||
												(group.candidateType === 'I' &&
													roles.includes(roledata.editIndividual))
										"
										v-b-popover.hover.top="'Edit'"
										src="../../assets/pencilicon.svg"
										alt=""
										class="ml-5 pointer"
										@click="editPerticularGroup(group, group.groupID)"
									/>
									<img
										v-if="group.view == false"
										v-b-popover.hover.top="'View'"
										src="../../assets/preview eye.svg"
										alt=""
										class="ml-3 pointer"
										@click="viewParticularGroup(group, group.groupID)"
									/>
									<img
										v-else
										v-b-popover.hover.top="'Close View'"
										src="../../assets/visibility_off.svg"
										class="ml-3 pointer"
										@click="unView(group)"
										alt=""
									/>
								</div>
							</div>
						</template>
					</div>

					<!-- table ends -->
					<div
						class="paginaTion d-flex justify-content-between align-items-center"
					>
						<div class="d-flex">
							<span class="qb-gotopage-text p-1">Go to Page</span>
							<b-form-input
								type="text"
								class="qb-pagination-num mr-1"
								v-model.trim="goToPage"
								@keypress="allowNumbers($event)"
								@keyup.enter="
									goToPage === null || goToPage == '' || !isValidPage
										? ''
										: goToPages(goToPage)
								"
							></b-form-input>
							<b-button
								:disabled="goToPage === null || goToPage == '' || !isValidPage"
								class="qb-pagination-addbtn"
								@click="goToPages(goToPage)"
							>
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>
						<div class="pagination margin-pgNo">
							<b-pagination
								v-model.number="currentPage"
								selectz
								@input="goToPageNum()"
								:total-rows="total"
								:per-page="count"
								align="center"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div class="qb-gotopage-text mr-2">
							Results :
							<span v-if="pageStart > total">0</span>
							<span v-else>{{ pageStart }}</span> - {{ pageEnd }} of
							{{ total }}
						</div>
					</div>
				</div>

				<div
					id="filtermodal"
					ref="recdropdown"
					v-if="filtermodalshow"
					class="sharepeople-filter-modal"
					v-closable="{
						exclude: ['rec', 'recdropdown'],
						handler: 'hideDropdown',
					}"
				>
					<div class="qb-fm-heading p-2">
						<div @click="closefilter()" class="xMarkCancel pointer">
							<img src="../../assets/xmark.svg" alt="" />
						</div>
						Filter By
					</div>
					<div class="topicfilterinnercard m-2">
						<div class="d-flex">
							<span>Evaluator <span class="asterik">*</span></span>
							<b-form-radio-group
								class="ml-3"
								:options="evaluatorOptions"
								v-model="evaluatorOption"
								value-field="item"
								text-field="name"
								disabled-field="notEnabled"
								size="sm"
							></b-form-radio-group>
						</div>
					</div>
					<div class="d-flex justify-content-between align-items-center p-2">
						<div
							class="clearfilter pointer mt-3"
							:class="
								evaluatorOption == null
									? filtercount == 0
										? 'disabled-text'
										: 'pointer'
									: 'pointer'
							"
							@click="clearfilter()"
						>
							Clear Filter
						</div>
						<div>
							<b-button
								class="addbtn"
								:disabled="evaluatorOption == null"
								@click="filter()"
							>
								Apply
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- *****************   VIEW GROUP DETAILS   ******************************* -->

		<Transition name="slide">
			<div
				v-if="
					grptype == 'view' &&
						grpcontainer &&
						selectedGroup.candidateType != 'I'
				"
				class="swp-group-detail-container p-3"
			>
				<div class="d-flex align-items-center justify-content-between">
					<div
						@click="cancelThis()"
						class="position-absolute pointer swp-backArrow"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">Group Details</div>
					<div class="d-flex align-items-center">
						<div
							class="mr-2 pointer"
							v-if="
								roles.includes(roledata.editGroup) &&
									selectedGroup.candidateType == 'G'
							"
						>
							<img
								v-b-popover.hover.top="'Edit'"
								src="../../assets/edit_Pencil.svg"
								alt=""
								class="mb-1"
								@click="editPerticularGroup(selectedGroup)"
							/>
						</div>
						<div @click="cancelThis()" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<hr />
				<div>
					<b-row>
						<b-col cols="6">
							<div class="swp-left-overflow pl-2 pt-2 pb-2">
								<div class="swp-left-card p-3">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="pr-tp-testhead">Group Name</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.groupName }}
											</div>
										</div>
									</div>
									<!-- <div
										v-if="selectedGroup.setPricing"
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead">List Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.listPrice }}
											</div>
										</div>
									</div>
									<div
										v-if="selectedGroup.setPricing"
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead">Final Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.finalPrice }}
											</div>
										</div>
									</div> -->
								</div>

								<div class="swp-left-view-cand-card p-3 mt-2">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/blueGroup.svg" alt="" />
											</div>
											<div class="swp-main-text ml-2">Candidates</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-3 mb-4"
									>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="swp-detail-text-1">Total Candidates</div>
											<div class="swp-detail-sub-text ml-3">
												{{ selectedGroup.candidateDets.length }}
											</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="swp-detail-text-1">Created on</div>
											<div class="swp-detail-sub-text ml-3">
												{{ selectedGroup.createdAt | datefilter }}
											</div>
										</div>
									</div>
									<div
										class="overflow-auto"
										:style="
											selectedGroup.candidateDets.length >= 10
												? 'max-height: calc(70vh - 130px);min-height:auto;padding-right:5px'
												: 'height:auto'
										"
										ref="hideDropdownsemaildataclass"
										v-closable="{
											exclude: ['hideDropdownsemaildataclass'],
											handler: 'hideDropdownsemaildata',
										}"
									>
										<div
											class="swp-candidate-table p-2"
											v-for="(data, i) in selectedGroup.candidateDets"
											:key="i"
											@click="data.currentLink == null ? '' : showData(i)"
											:class="data.currentLink == null ? '' : 'pointer'"
										>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div
													class="sec-checboxtext swp-previous-link mr-2"
													v-b-popover.hover.top.v-info="`${data.emailID}`"
													variant="info"
												>
													{{ data.emailID | filetrEmails }}
												</div>
												<div class="d-flex align-items-center">
													<div
														v-if="data.shareStatus"
														class="d-flex align-items-center justify-content-between mr-5"
													>
														<div>
															<img
																src="../../assets/icons/Reports/sharedgreenicon.svg"
																alt=""
															/>
														</div>
														<div class="swp-detail-text ml-1 mt-1">Shared</div>
													</div>
													<div v-if="data.currentLink != null">
														<img src="../../assets/downarrow.svg" alt="" />
													</div>
												</div>
											</div>
											<div class="p-1 mt-2" v-show="shouldShowDropdown(i)">
												<div
													class="swp-activetext"
													v-if="data.currentLink == null"
												>
													Not shared please click share link
												</div>
												<div v-if="data.currentLink != null">
													<div class="swp-activetext">Current Link</div>
													<div>
														<div
															class="sec-ques-style"
															disabled
															rows="2"
															max-rows="2"
															width="100%"
														>
															{{ data.currentLink }}
														</div>
													</div>
												</div>
												<div v-if="data.prevLink.length !== 0">
													<hr />
													<div class="shareview-details-email">
														Previous Link
													</div>
													<div
														v-for="(data, i) in data.prevLink"
														:key="i"
														style="opacity: 0.9"
													>
														<div
															class="sec-ques-style"
															disabled
															rows="2"
															max-rows="2"
															width="100%"
														>
															{{ data }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-col>

						<b-col cols="6">
							<div class="swp-left-card p-3" v-if="selectedGroup.setPricing">
								<div class="w-100">
									<div class="d-flex align-items-center">
										<div>
											<img src="../../assets/pricing.svg" alt="" />
										</div>
										<div class="ml-2 swp-main-text text-truncate">
											Pricing Details
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead">List Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.listPrice }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead">Discount Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.discountAmount }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead">Final Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												{{ selectedGroup.finalPrice }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead w-75">
											Payment Gateway Charges
										</div>
										<div class="d-flex justify-content-end">
											<div class="swp-main-text text-truncate">
												{{ gatewayPercent }}%
											</div>
										</div>
									</div>
									<hr class="my-2" />
									<div
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead fw-500 color-333333 w-75">
											Final Amount Receivable
										</div>
										<div class="d-flex justify-content-end">
											<div class="swp-main-text fw-600 color-333333">
												₹{{
													selectedGroup.finalPrice -
														(selectedGroup.finalPrice * gatewayPercent) / 100
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="pl-2 pr-2 pt-2 pb-2 swp-right-view-group-overflow">
								<div class="swp-left-card-height p-3">
									<div class="d-flex align-items-center">
										<div>
											<img src="../../assets/greenEvaluator.svg" alt="" />
										</div>
										<div class="swp-main-text ml-2">Evaluators</div>
									</div>
									<div class="d-flex justify-content-between">
										<div class="swp-detail-text-1 mt-2">Total Evaluators</div>
										<div class="swp-detail-sub-text mt-2">
											{{ groupDatas.evaluator.length }}
										</div>
									</div>
									<hr />
									<div
										class="overflow-auto"
										:style="
											groupDatas.evaluator.length >= 8
												? 'max-height:calc(40vh - 145px);min-height:auto;padding-right:5px'
												: 'height:auto'
										"
									>
										<div
											v-for="(data, i) in groupDatas.evaluator"
											:key="i"
											class="d-flex align-items-center p-1"
										>
											<div>
												<img src="../../assets/orangeProfile.svg" alt="" />
											</div>
											<div class="ml-2 shareview-details-email mr-2">
												{{ data.email }}
											</div>
										</div>
									</div>
								</div>
								<div
									class="swp-left-card p-3 mt-2"
									v-if="selectedGroup.shareLink == null"
								>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="pr-tp-testhead">Assessment Link</div>

										<span
											v-if="selectedGroup.shareLink == null"
											v-b-tooltip.hover="{ variant: 'secondary' }"
											:title="
												evaluatorTagged == false &&
												selectedGroup.evaluator.length == 0
													? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
													: selectedGroup.configured == false
													? 'Tag Configuration To Generate Link'
													: selectedGroup.open == 'False'
													? 'Tag Active Configuration To Generate Link'
													: ''
											"
										>
											<span class="deliveredtext"> Link Not Generated </span>
										</span>
									</div>
								</div>
								<div
									v-if="selectedGroup.shareLink != null"
									class="swp-left-card-view-Assessment-Link p-3 mt-2"
								>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="pr-tp-testhead">Assessment Link</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between"
										:class="selectedGroup.shareLink == null ? '' : 'mb-2'"
									>
										<div class="swp-activetext mt-2">Current Link</div>
									</div>
									<div class="swp-textarea swp-link-text p-2">
										{{ selectedGroup.shareLink }}
									</div>
									<div v-if="selectedGroup.prevLinks.length !== 0">
										<hr />
										<div class="shareview-details-email">Previous Link</div>
										<div
											class="overflow-auto p-1"
											:style="
												selectedGroup.prevLinks.length >= 2
													? 'max-height: calc(40vh - 189px);min-height:auto;padding-right:5px'
													: 'height:auto'
											"
										>
											<div
												style="opacity: 0.9"
												v-for="(data, i) in selectedGroup.prevLinks"
												:key="i"
											>
												<div class="swp-textarea swp-link-text p-2 mt-1 mb-1">
													{{ data }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="swp-left-card p-3 mt-2">
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div class="pr-tp-testhead">Configure</div>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div>
												<div class="mr-3">
													<span
														v-if="selectedGroup.configured == false"
														class="deliveredtext"
														>Not Configured</span
													>

													<span
														v-else-if="selectedGroup.open == 'False'"
														class="expiredClass"
														>Expired</span
													>
													<span
														v-else
														class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center mr-3"
														>Active</span
													>
												</div>
											</div>
										</div>
									</div>
									<div
										class="swp-greyBackground p-2 mt-3"
										v-if="selectedGroup.configured == true"
									>
										<div class="answertext">
											Configuration Name : {{ selectedGroup.configName }}
										</div>
									</div>
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
		</Transition>

		<!-- *****************   EDIT GROUP DETAILS   ******************************* -->

		<Transition name="slide">
			<div
				v-if="
					grptype == 'edit' &&
						grpcontainer &&
						selectedGroup.candidateType != 'I' &&
						editIndividual == false
				"
				class="swp-group-detail-container"
			>
				<div class="p-3">
					<div class="d-flex align-items-center justify-content-between">
						<div
							@click="cancelThis()"
							class="position-absolute pointer swp-backArrow"
						>
							<img src="../../assets/backArrow.svg" alt="" />
						</div>
						<div class="swp-group-main-heading ml-3 mt-2">Edit Group</div>
						<div @click="cancelThis()" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
					<hr />
					<div class="swp-eg">
						<b-row>
							<b-col cols="6">
								<div class="pl-2 pt-2 pb-2">
									<div class="swp-left-card p-3">
										<div class="">
											<div class="pr-tp-testhead">Group Name</div>

											<div class="topDiv mt-4">
												<label class="fieldsetStyle"
													>Group Name &nbsp;<span class="asterik"
														>*</span
													></label
												>
												<b-form-input
													class="inputField swp-inside-text"
													id="input-1"
													placeholder="Enter Group Name"
													v-model.trim="selectedGroup.groupName"
													:class="{ error: $v.selectedGroup.groupName.$error }"
													:disabled="selectedGroup.candidateType == 'R'"
												>
												</b-form-input>
												<div
													style="position: absolute; top: 5px; right: 12px"
													v-if="
														$v.selectedGroup.groupName.$dirty &&
															!$v.selectedGroup.groupName.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 5px; right: 12px"
													v-if="
														!$v.selectedGroup.groupName.maxLength &&
															$v.selectedGroup.groupName.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Should not exceed 128 characters',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
											</div>
										</div>
									</div>

									<div
										:style="
											selectedGroup.candidates.length >= 6
												? 'height:70vh'
												: 'height:auto'
										"
										class="swp-left-card-candidates pt-3 pl-3 pr-3 mt-2"
									>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center">
												<div>
													<img src="../../assets/blueGroup.svg" alt="" />
												</div>
												<div class="swp-main-text ml-2">Candidates</div>
											</div>
											<div></div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between mt-3 mb-4"
										>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="swp-detail-text-1">Total Candidates</div>
												<div class="swp-detail-sub-text ml-3">
													{{ selectedGroup.candidates.length }}
												</div>
											</div>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="swp-detail-text-1">Created on</div>
												<div class="swp-detail-sub-text ml-3">
													{{ selectedGroup.createdAt | datefilter }}
												</div>
											</div>
										</div>
										<hr />

										<div class="relativeclass mt-4" ref="dropdownmailids">
											<div
												v-b-modal.excel-modal
												class="clearfilter import-excel-pos"
											>
												Import excel
											</div>
											<div
												v-if="selectedGroup.candidateType == 'G'"
												class="relativeclass mt-3 pointer"
												@click="toggleDropdownmailids"
											>
												<label class="fieldsetStyle"
													>Email Id&nbsp;<span class="asterik">*</span></label
												>
												<b-form-tags
													v-model="selectedGroup.candidates"
													no-outer-focus
													class="mb-2 groupshare-formtag"
													separator=" ,;"
												>
													<template v-slot="{ inputAttrs, inputHandlers }">
														<b-input-group aria-controls="my-custom-tags-list">
															<b-form-input
																v-on:keyup.enter="customHandlerEdit"
																v-bind="inputAttrs"
																v-model.trim="editIndividualEmail"
																v-on="inputHandlers"
																@keyup="mailids = true"
																@input="converEditIndividualEmail()"
																placeholder="New Email - Enter or Search To Add"
																:class="
																	$v.editIndividualEmail.$error ||
																	emailSelectedEmpty ||
																	groupLengthError
																		? 'error'
																		: ''
																"
															></b-form-input>
															<div
																style="
                                  position: absolute;
                                  top: 5px;
                                  right: 35px;
                                "
																v-if="
																	$v.editIndividualEmail.$dirty &&
																		!$v.editIndividualEmail.required
																"
																v-b-popover.hover.top.v-danger="{
																	content: 'Required',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>

															<div
																style="
                                  position: absolute;
                                  top: 5px;
                                  right: 35px;
                                "
																v-if="emailSelectedEmpty || groupLengthError"
																v-b-popover.hover.top.v-danger="{
																	content: 'Two or more candidates required',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
															<div
																style="
                                  position: absolute;
                                  top: 5px;
                                  right: 35px;
                                "
																v-if="
																	!$v.editIndividualEmail.alpha ||
																		($v.editIndividualEmail.required &&
																			!$v.editIndividualEmail.email)
																"
																v-b-popover.hover.top.v-danger="{
																	content: 'Invalid email address',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>

															<b-input-group-append class="addtaginput">
																<b-button
																	@click="customEdit(inputAttrs)"
																	variant="outline"
																	class="cursor-pointer p-2"
																>
																	<img
																		src="../../assets/addicongraywhite.svg"
																		alt=""
																	/>
																</b-button>
															</b-input-group-append>
														</b-input-group>
													</template>
												</b-form-tags>
											</div>
											<div
												v-if="mailids && optionssearchedit.length > 0"
												class="grp-sec-modal sharemailbtns groupOptionsDiv-2 pointer"
												style="
                          min-height: auto;
                          max-height: 200px;
                          overflow: auto;
                        "
											>
												<div class="w-100">
													<div
														v-for="(i, index) in optionssearchedit"
														:key="index"
														style="display: grid"
														class="p-2 swp-jdTypeCheck swp-check-email text-truncate wordbreak"
														v-b-popover.hover.top.v-info="`${i.groupName}`"
													>
														<b-form-checkbox
															v-model="selectedGroup.candidates"
															:value="i.groupName"
															@change="changeEmptyEmail"
														>
															{{ i.groupName }}
														</b-form-checkbox>
													</div>
												</div>
											</div>

											<!-- ----------ish design -->

											<!-- ----------ish design -->
										</div>
										<div
											class="overflow-auto pl-1"
											:style="
												selectedGroup.candidates.length >= 6
													? 'height:calc(100vh - 570px);padding-right:10px'
													: 'height:auto'
											"
										>
											<div
												class="mb-3"
												v-for="(email, index) in selectedGroup.candidates"
												:key="index"
											>
												<div
													class="d-flex align-items-center justify-content-between"
												>
													<div
														class="d-flex align-items-center"
														style="width: 75%"
													>
														<span
															><img
																src="../../assets/icons/Reports/singlepep.svg"
																alt=""
																class="mr-2"
														/></span>
														<div
															class="shareview-details-email mt-1 text-truncate"
														>
															{{ email }}
														</div>
													</div>
													<div
														class="swp-share-link-text mt-1 pointer"
														@click="shareToIndividual(email)"
														v-if="selectedGroup.shareLink != null"
													>
														Share link
													</div>
													<div
														class="shareview-details-text mt-1 pointer"
														v-if="selectedGroup.candidateType == 'G'"
													>
														<span
															><img
																v-b-popover.hover.top="'Remove'"
																src="../../assets/icons/Reports/removeEmail.svg"
																alt=""
																class="mt-1 pointer"
																@click="removeEmail(index)"
														/></span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</b-col>

							<b-col cols="6" class="h-100">
								<div class="pr-2 pt-2 pb-2 pl-2 swp-right-overflow">
									<div class="swp-left-card-evaluators p-2 mb-3">
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/pricing.svg" alt="" />
											</div>
											<div
												class="ml-2 swp-main-text text-truncate d-flex align-items-center"
											>
												Pricing Details
												<b-form-checkbox
													class="ml-2"
													switch
													v-model="setPricing"
													@change="hideshowPricingDetails"
												/>
											</div>
										</div>

										<div
											class="d-flex align-items-center mt-3 access-switch position-relative"
										>
											<b-col class="pl-0">
												<div class="topDiv mt-3">
													<label class="fieldsetStyle" v-if="setPricing"
														>List Price(Rs.) &nbsp;<span class="asterik"
															>*</span
														></label
													>
													<b-form-input
														class="viewcon-inputField"
														placeholder="Enter here"
														v-model.number="$v.listPrice.$model"
														:class="{ error: $v.listPrice.$error }"
														:disabled="!setPricing"
														type="number"
													></b-form-input>
													<div
														style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
														v-if="$v.listPrice.$dirty && !$v.listPrice.required"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>

													<div
														style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
														v-if="$v.listPrice.$dirty && !$v.listPrice.between"
														v-b-popover.hover.top.v-danger="{
															content: 'Must be between 0 and 100000',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
													<div
														style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
														v-if="
															$v.listPrice.$dirty &&
																!$v.listPrice.maxFiveDecimals
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Must have at most 5 decimal places',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
												</div>
											</b-col>
											<b-col class="pr-0">
												<div class="topDiv mt-3">
													<label class="fieldsetStyle" v-if="setPricing"
														>Discount(Rs.) &nbsp;</label
													>
													<b-form-input
														class="viewcon-inputField"
														placeholder="Enter here"
														v-model.number="$v.discount.$model"
														:class="{ error: $v.discount.$error }"
														:disabled="!setPricing"
														type="number"
													></b-form-input>
													<div
														style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
														v-if="!$v.discount.minValue"
														v-b-popover.hover.top.v-danger="{
															content:
																'Discount Price Cannot be negative number',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>

													<div
														style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
														v-if="
															$v.discount.$dirty &&
																!$v.discount.notGreaterThanList
														"
														v-b-popover.hover.top.v-danger="{
															content:
																'Discount cannot exceed or be equal list price',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>

													<div
														style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
														v-if="
															$v.discount.$dirty && !$v.discount.maxFiveDecimals
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Must have at most 5 decimal places',
														}"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
												</div>
											</b-col>
										</div>
										<div class="fw-500 fs-10 color-7a7a7a fam-lato">
											Discount Price should be lesser than List price
										</div>
										<section class="mt-4" v-if="setPricing">
											<div
												class="d-flex align-items-center justify-content-between mt-2"
											>
												<div class="pr-tp-testhead">List Price</div>
												<div
													class="d-flex justify-content-end"
													style="width: 60%"
												>
													<div class="swp-main-text text-truncate">
														₹{{ listPrice }}
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-center justify-content-between mt-1"
											>
												<div class="pr-tp-testhead">Discount Price</div>
												<div
													class="d-flex justify-content-end"
													style="width: 60%"
												>
													<div class="swp-main-text text-truncate">
														₹{{ discount }}
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-center justify-content-between mt-1"
											>
												<div class="pr-tp-testhead">Final Price</div>
												<div
													class="d-flex justify-content-end"
													style="width: 60%"
												>
													<div class="swp-main-text text-truncate">
														₹{{ priceAfterDiscount }}
													</div>
												</div>
											</div>
											<div
												class="d-flex align-items-center justify-content-between mt-1"
											>
												<div class="pr-tp-testhead w-75">
													Payment Gateway Charges
												</div>
												<div class="d-flex justify-content-end">
													<div class="swp-main-text text-truncate">
														{{ gatewayPercent }}%
													</div>
												</div>
											</div>
											<hr class="my-2" />
											<div
												class="d-flex align-items-center justify-content-between mt-2"
											>
												<div class="fs-13 fw-500 color-333333 w-75">
													Final Amount Receivable
												</div>
												<div class="d-flex justify-content-end">
													<div class="swp-main-text fw-600 color-333333">
														₹{{ finalReceivable }}
													</div>
												</div>
											</div>
										</section>
									</div>
									<div class="swp-left-card-evaluators p-2">
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/greenEvaluator.svg" alt="" />
											</div>
											<div class="swp-main-text ml-2">Evaluators</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-start mt-3"
										>
											<div class="swp-detail-text-1">Total Evaluators :</div>
											<div class="swp-detail-sub-text ml-3">
												{{ selectedGroup.evaluator.length }}
											</div>
										</div>
										<hr />

										<div>
											<div
												class="topDiv position-relative mt-1"
												ref="expdropdownIndividualEmailEDIT"
												v-closable="{
													exclude: ['expdropdownIndividualEmailEDIT'],
													handler: 'hideexpertiseoptionsIndividualEmailEDIT',
												}"
											>
												<label class="fieldsetStyle sharelabel"
													>Select Evaluators<span
														v-if="!evaluatorTagged"
														class="asterik"
														>*</span
													></label
												>
												<div
													:class="
														$v.selectedGroup.evaluator.$dirty &&
														!$v.selectedGroup.evaluator.required
															? 'error'
															: ''
													"
													class="qb-dropdown-diffy d-flex justify-content-between pointer"
													@click="
														(evaluatorSelect = !evaluatorSelect),
															(evalSearch = null)
													"
												>
													<span v-if="selectedGroup.evaluator.length == 0"
														>Select Evaluators</span
													>
													<span v-if="selectedGroup.evaluator.length == 1">
														{{ selectedGroup.evaluator.length }} Evaluator
														selected
													</span>
													<span v-if="selectedGroup.evaluator.length > 1"
														>{{ selectedGroup.evaluator.length }} Evaluators
														selected</span
													>

													<span @click="evaluatorSelect = !evaluatorSelect">
														<img
															v-if="evaluatorSelect"
															src="../../assets/uparrow.svg"
															alt=""
															class="mr-1"
														/>
														<img
															v-else
															src="../../assets/downarrow.svg"
															alt=""
															class="mr-1"
														/>
													</span>
												</div>
												<div
													style="position: absolute; top: 5px; right: 35px"
													v-if="
														$v.selectedGroup.evaluator.$dirty &&
															!$v.selectedGroup.evaluator.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													v-if="evaluatorSelect"
													class="swp-qb-dropdown-option-add w-100 widoption sharemailbtns"
												>
													<div class="groupshare-searchicon">
														<img src="../../assets/searchicon.svg" alt="" />
													</div>
													<b-form-input
														type="search"
														v-model="evalSearch"
														placeholder="Search Evaluator"
														class="groupshare-seachinput"
													></b-form-input>
													<div class="swp-groupOptionsDivUpadte p-1 pointer">
														<div class="swp-checkboxcontainer w-100">
															<div
																class="p-2 swp-jdTypeCheck text-truncate wordbreak"
																v-for="(evaluator, i) in evalOptionSearch"
																:key="i"
															>
																<b-form-checkbox
																	v-model="selectedGroup.evaluator"
																	:value="evaluator"
																	class="sec-checboxtext swp-check-email mr-2"
																>
																	{{ evaluator.name }}
																</b-form-checkbox>
															</div>
															<div
																v-if="evalOptionSearch.length == 0"
																class="noSearchResultsText"
															>
																No results found for "{{ evalSearch }}"
																evaluator.
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="swp-edit-group-evaluator-overflow">
												<div
													v-for="(data, i) in selectedGroup.evaluator"
													:key="i"
													class="d-flex align-items-center justify-content-between mt-3"
												>
													<div class="d-flex align-items-center">
														<div>
															<img
																src="../../assets/orangeProfile.svg"
																alt=""
															/>
														</div>
														<div class="ml-2 shareview-details-email mr-2">
															{{ data.email }}
														</div>
													</div>
													<span
														><img
															v-b-popover.hover="'Remove'"
															@click="removeEvaluator(i)"
															src="../../assets/icons/Reports/removeEmail.svg"
															alt=""
															class="mt-1 pointer"
													/></span>
												</div>
											</div>
										</div>
									</div>
									<div
										class="swp-left-card p-3 mt-2"
										v-if="selectedGroup.shareLink == null"
									>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="pr-tp-testhead">Assessment Link</div>
											<span
												v-if="
													selectedGroup.candidateType == 'R' &&
														selectedGroup.shareLink == null
												"
											>
												<span class="deliveredtext"> Link Not Generated </span>
											</span>

											<span
												class="d-flex align-items-center"
												v-if="
													selectedGroup.shareLink == null &&
														selectedGroup.candidateType == 'G'
												"
												@click="
													selectedGroup.configured == false ||
													selectedGroup.open == 'False' ||
													(evaluatorTagged == false &&
														selectedGroup.evaluator.length == 0)
														? ''
														: generatelink(selectedGroup.groupID)
												"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												:title="
													evaluatorTagged == false &&
													selectedGroup.evaluator.length == 0
														? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
														: selectedGroup.configured == false
														? 'Tag Configuration To Generate Link'
														: selectedGroup.open == 'False'
														? 'Tag Active Configuration To Generate Link'
														: ''
												"
											>
												<span>
													<img
														src="../../assets/generate link icon.svg"
														alt=""
														v-if="
															selectedGroup.configured == false ||
																selectedGroup.open == 'False' ||
																(evaluatorTagged == false &&
																	selectedGroup.evaluator.length == 0)
														"
													/>
													<img
														v-else
														src="../../assets/icons/Reports/enableupdate.svg"
														alt=""
													/>
												</span>

												<span
													:class="
														selectedGroup.configured == false ||
														selectedGroup.open == 'False' ||
														(evaluatorTagged == false &&
															selectedGroup.evaluator.length == 0)
															? 'disablesharetext'
															: 'pr-tp-testhead pointer'
													"
												>
													Generate Link
												</span>
											</span>
										</div>
									</div>
									<div
										v-if="selectedGroup.shareLink != null"
										class="swp-left-card-Assessment-group-edit-Link p-2 mt-2"
									>
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="pr-tp-testhead">Assessment Link</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between"
											:class="selectedGroup.shareLink == null ? '' : 'mb-2'"
										>
											<div class="swp-activetext">Current Link</div>
											<div class="d-flex align-items-center">
												<div
													class="d-flex align-items-center justify-content-between pointer"
													v-if="selectedGroup.candidateType == 'G'"
												>
													<div>
														<span
															class="pointer"
															v-b-tooltip.hover="{ variant: 'secondary' }"
															:title="
																evaluatorTagged == false && evaluatorLength == 0
																	? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Update Link'
																	: selectedGroup.open == 'False'
																	? 'Tag Active Configuration To Update Link'
																	: ''
															"
															:class="
																(evaluatorTagged == false &&
																	evaluatorLength == 0) ||
																selectedGroup.open == 'False'
																	? 'disablesharetext'
																	: ''
															"
														>
															<img
																src="../../assets/generate link icon.svg"
																alt=""
																v-if="
																	(evaluatorTagged == false &&
																		evaluatorLength == 0) ||
																		selectedGroup.open == 'False'
																"
															/><img
																v-else
																src="../../assets/update-arrows-svgrepo-com 1refresh.svg"
																alt=""
																@click="
																	(updatelink = true),
																		generatelink(selectedGroup.groupID)
																"
															/>
															<span
																v-if="
																	(evaluatorTagged == false &&
																		evaluatorLength == 0) ||
																		selectedGroup.open == 'False'
																"
															>
																Update Link
															</span>

															<span
																v-else
																class="updateLink"
																@click="
																	(updatelink = true),
																		generatelink(selectedGroup.groupID)
																"
																>Update Link
															</span>
														</span>
													</div>
												</div>
												<div class="ml-3 pointer">
													<div class="ml-3">
														<div
															v-if="
																selectedGroup.shareLink == null ||
																	selectedGroup.open == 'False' ||
																	(evaluatorTagged == false &&
																		selectedGroup.evaluator.length == 0)
															"
															v-b-tooltip.hover="{ variant: 'secondary' }"
															:title="
																evaluatorTagged == false &&
																selectedGroup.evaluator.length == 0
																	? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Share Link'
																	: selectedGroup.configured == false
																	? 'Tag Configuration To Share Link'
																	: selectedGroup.open == 'False'
																	? 'Tag Active Configuration To Share Link'
																	: 'share link'
															"
														>
															<img
																src="../../assets/icons/Reports/disableshareicon.svg"
																alt=""
															/>

															<span class="disablesharetext"> Share link </span>
														</div>

														<div
															v-else
															v-b-popover.hover.top="'Share to all'"
															@click="shareLink(selectedGroup.groupID)"
														>
															<img
																src="../../assets/icons/Reports/enableshareicon.svg"
																alt=""
															/>
															<span class="updateLink ml-1">Share link </span>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="swp-textarea swp-link-text p-2">
											{{ selectedGroup.shareLink }}
										</div>
										<div v-if="selectedGroup.prevLinks.length !== 0">
											<hr />
											<div class="shareview-details-email">Previous Link</div>
											<div class="swp-edit-group-assessmentLink-overflow p-1">
												<div
													v-for="(data, i) in selectedGroup.prevLinks"
													style="opacity: 0.9"
													:key="i"
												>
													<div class="swp-textarea swp-link-text p-2 mt-1 mb-1">
														{{ data }}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="swp-left-card p-3 mt-2">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="pr-tp-testhead">Configure</div>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div>
													<div class="mr-3">
														<span
															v-if="selectedGroup.configured == false"
															class="deliveredtext"
															>Add Configuration</span
														>

														<span
															v-else-if="selectedGroup.open == 'False'"
															class="expiredClass"
															>Expired</span
														>
														<span
															v-else
															class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center mr-3"
															>Active</span
														>
													</div>
												</div>
												<div
													class="pointer"
													v-if="roles.includes(roledata.getconfig)"
												>
													<img
														v-if="selectedGroup.configured == false"
														v-b-popover.hover.top="'Add Configuration'"
														src="../../assets/icons/Reports/notConfigured.svg"
														alt=""
														@click="goToConfigure(selectedGroup)"
													/>
													<img
														v-else
														v-b-popover.hover.top="'Configure'"
														src="../../assets/icons/Reports/enableconfigicon.svg"
														alt=""
														@click="goToConfigure(selectedGroup)"
													/>
												</div>
											</div>
										</div>
										<div
											class="swp-greyBackground p-2 mt-3"
											v-if="selectedGroup.configured == true"
										>
											<div class="answertext">
												Configuration Name : {{ selectedGroup.configName }}
											</div>
										</div>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>
				</div>
				<div class="swp-group-detail-footer d-flex justify-content-end p-3">
					<div
						@click="cancelThis(), (grpcontainer = false)"
						class="swp-cancelbtntext pointer"
					>
						Cancel
					</div>
					<b-button
						@click="
							editIndividual == false ? updateGroup() : updateIndividual()
						"
						class="ml-2 swp-addbtn pointer"
					>
						Update
					</b-button>
				</div>
			</div>
		</Transition>

		<!-- *****************   VIEW INDIVIDUAL   ******************************* -->

		<Transition name="slide">
			<div
				v-if="
					grptype == 'view' &&
						grpcontainer &&
						selectedGroup.candidateType != 'G' &&
						selectedGroup.candidateType != 'R'
				"
				class="swp-group-detail-half-container p-3"
			>
				<div class="d-flex align-items-center justify-content-between">
					<div
						@click="cancelThis()"
						class="position-absolute pointer swp-backArrow"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">View Individual</div>
					<div class="d-flex align-items-center">
						<div
							class="mr-2 pointer"
							v-if="roles.includes(roledata.editIndividual)"
						>
							<img
								v-b-popover.hover.top="'Edit'"
								src="../../assets/edit_Pencil.svg"
								alt=""
								class="mb-1"
								@click="editPerticularGroup(selectedGroup)"
							/>
						</div>
						<div @click="cancelThis()" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<hr />
				<section style="height:calc(100vh - 180px)" class="overflow-auto">
					<div class="p-2 w-100">
						<div class="swp-left-view-individual-card p-3 w-100">
							<div class="w-100">
								<div class="d-flex align-items-center">
									<div>
										<img src="../../assets/orangeProfile.svg" alt="" />
									</div>
									<div class="ml-2 swp-main-text text-truncate">
										{{ selectedGroup.groupName }}
									</div>
								</div>
							</div>
							<div class="d-flex align-items-center" style="width: 15%">
								<div
									v-if="selectedGroup.shareStatus == 'shared'"
									class="d-flex align-items-center justify-content-between"
								>
									<div>
										<img
											src="../../assets/icons/Reports/sharedgreenicon.svg"
											alt=""
										/>
									</div>
									<div
										class="swp-detail-text mt-1 ml-1"
										style="font-size: 12px"
									>
										Shared
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- pricing card -->
					<div class="p-2 w-100" v-if="selectedGroup.setPricing">
						<div class="swp-left-view-individual-card p-3 w-100">
							<div class="w-100">
								<div class="d-flex align-items-center">
									<div>
										<img src="../../assets/pricing.svg" alt="" />
									</div>
									<div class="ml-2 swp-main-text text-truncate">
										Pricing Details
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-2"
								>
									<div class="pr-tp-testhead">List Price</div>
									<div class="d-flex justify-content-end" style="width: 60%">
										<div class="swp-main-text text-truncate">
											{{ selectedGroup.listPrice }}
										</div>
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="pr-tp-testhead">Discount Price</div>
									<div class="d-flex justify-content-end" style="width: 60%">
										<div class="swp-main-text text-truncate">
											{{ selectedGroup.discountAmount }}
										</div>
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="pr-tp-testhead">Final Price</div>
									<div class="d-flex justify-content-end" style="width: 60%">
										<div class="swp-main-text text-truncate">
											{{ selectedGroup.finalPrice }}
										</div>
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="pr-tp-testhead w-75">Payment Gateway Charges</div>
									<div class="d-flex justify-content-end">
										<div class="swp-main-text text-truncate">
											{{ gatewayPercent }}%
										</div>
									</div>
								</div>
								<hr class="my-2" />
								<div
									class="d-flex align-items-center justify-content-between mt-2"
								>
									<div class="pr-tp-testhead fw-500 color-333333 w-75">
										Final Amount Receivable
									</div>
									<div class="d-flex justify-content-end">
										<div class="swp-main-text fw-600 color-333333">
											₹{{
												selectedGroup.finalPrice -
													(selectedGroup.finalPrice * gatewayPercent) / 100
											}}
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex align-items-center" style="width: 15%">
								<div
									v-if="selectedGroup.shareStatus == 'shared'"
									class="d-flex align-items-center justify-content-between"
								>
									<div>
										<img
											src="../../assets/icons/Reports/sharedgreenicon.svg"
											alt=""
										/>
									</div>
									<div
										class="swp-detail-text mt-1 ml-1"
										style="font-size: 12px"
									>
										Shared
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="swp-view-individual-overflow p-2">
						<div class="swp-trial-card p-3">
							<div class="d-flex align-items-center">
								<div>
									<img src="../../assets/greenEvaluator.svg" alt="" />
								</div>
								<div class="swp-main-text ml-2">Evaluators</div>
							</div>
							<div class="d-flex justify-content-between mt-2 w-100">
								<div class="swp-detail-text-1">Total Evaluators</div>
								<div class="swp-detail-sub-text">
									{{ evaluatorLength }}
								</div>
							</div>
							<span v-if="selectedGroup.evaluator.length > 0">
								<hr />
							</span>
							<div
								class="overflow-auto"
								:style="
									selectedGroup.evaluator.length >= 8
										? 'height: calc(40vh - 145px);'
										: 'height:auto'
								"
							>
								<div
									v-for="(data, i) in selectedGroup.evaluator"
									:key="i"
									class="d-flex p-1"
								>
									<div>
										<img src="../../assets/orangeProfile.svg" alt="" />
									</div>
									<div class="ml-2 shareview-details-email mr-2">
										{{ data.name }}
									</div>
								</div>
							</div>
						</div>
						<div
							class="swp-left-card p-3 mt-2"
							v-if="selectedGroup.shareLink == null"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="pr-tp-testhead">Assessment Link</div>

								<span
									v-if="selectedGroup.shareLink == null"
									v-b-tooltip.hover="{ variant: 'secondary' }"
									:title="
										evaluatorTagged == false &&
										selectedGroup.evaluator.length == 0
											? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
											: selectedGroup.configured == false
											? 'Tag Configuration To Generate Link'
											: selectedGroup.open == 'False'
											? 'Tag Active Configuration To Generate Link'
											: ''
									"
								>
									<span class="deliveredtext"> Link Not Generated </span>
								</span>
							</div>
						</div>
						<div
							v-if="selectedGroup.shareLink != null"
							class="swp-left-card-Assessment-Link p-3 mt-2"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="pr-tp-testhead">Assessment Link</div>
							</div>
							<div class="p-1 mt-2">
								<div
									class="d-flex align-items-center justify-content-between mb-2"
								>
									<div class="swp-activetext">Current Link</div>
								</div>
								<div class="swp-textarea swp-link-text p-2">
									{{ selectedGroup.shareLink }}
								</div>
								<div v-if="selectedGroup.prevLinks.length !== 0">
									<hr />
									<div class="shareview-details-email">Previous Link</div>
									<div
										class="overflow-auto"
										:style="
											selectedGroup.prevLinks.length >= 2
												? 'max-height: calc(40vh - 189px);min-height:auto;padding-right:5px'
												: 'height:auto'
										"
									>
										<div
											v-for="(data, i) in selectedGroup.prevLinks"
											:key="i"
											style="opacity: 0.9"
										>
											<div class="swp-textarea swp-link-text p-2 mt-1">
												{{ data }}
											</div>
										</div>
										<div></div>
									</div>
								</div>
							</div>
						</div>
						<div class="swp-left-card p-3 mt-2">
							<div class="d-flex align-items-center justify-content-between">
								<div class="pr-tp-testhead">Configure</div>
								<div class="d-flex align-items-center justify-content-between">
									<div>
										<div class="mr-3">
											<span
												v-if="selectedGroup.configured == false"
												class="deliveredtext"
												>Not Configured</span
											>

											<span
												v-else-if="selectedGroup.open == 'False'"
												class="expiredClass"
												>Expired</span
											>
											<span
												v-else
												class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center mr-3"
												>Active</span
											>
										</div>
									</div>
								</div>
							</div>
							<div
								class="swp-greyBackground p-2 mt-3"
								v-if="selectedGroup.configured == true"
							>
								<div class="answertext text-break">
									Configuration Name : {{ selectedGroup.configName }}
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</Transition>

		<!-- *****************   EDIT INDIVIDUAL   ******************************* -->

		<Transition name="slide">
			<div
				v-if="
					grptype == 'edit' &&
						grpcontainer &&
						selectedGroup.candidateType != 'G' &&
						editIndividual == true &&
						selectedGroup.candidateType != 'R'
				"
				class="swp-group-detail-half-container"
			>
				<div class="p-3">
					<div class="d-flex align-items-center justify-content-between">
						<div
							@click="cancelThis()"
							class="position-absolute pointer swp-backArrow"
						>
							<img src="../../assets/backArrow.svg" alt="" />
						</div>
						<div class="swp-group-main-heading ml-3 mt-2">Edit Individual</div>
						<div @click="cancelThis()" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
					<hr />

					<div class="p-2">
						<div class="topDiv mt-2">
							<label class="fieldsetStyle"
								>Email &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								class="testconfiginputField swp-inside-text"
								id="input-2"
								@click="individualmail = !individualmail"
								@input="(individualmail = true), convertToLowerCase()"
								v-model="individualCandidate"
								placeholder="Enter Email ID"
								type="text"
								disabled
								:class="{ error: $v.individualCandidate.$error }"
							>
							</b-form-input>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									$v.individualCandidate.$dirty &&
										!$v.individualCandidate.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									!$v.individualCandidate.alpha ||
										($v.individualCandidate.required &&
											!$v.individualCandidate.email)
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Invalid email address',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>
					<div style="height: calc(100vh - 306px)">
						<div class="swp-edit-individual-overflow p-2">
							<div class="swp-left-card-evaluators-ei p-2 mt-2">
								<div class="d-flex align-items-center">
									<div>
										<img src="../../assets/greenEvaluator.svg" alt="" />
									</div>
									<div class="swp-main-text ml-2">Evaluators</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-start mt-3"
								>
									<div class="swp-detail-text-1">Total Evaluators</div>
									<div class="swp-detail-sub-text ml-3">
										{{ selectedGroup.evaluator.length }}
									</div>
								</div>
								<hr />

								<div>
									<div
										class="topDiv position-relative mt-1 expdropdownEditIndividual"
										v-closable="{
											exclude: ['expdropdownEditIndividual'],
											handler: 'hideexpertiseoptionsEditIndividual',
										}"
									>
										<label class="fieldsetStyle sharelabel"
											>Select Evaluators<span
												v-if="!evaluatorTagged"
												class="asterik"
												>*</span
											></label
										>
										<div
											:class="
												selevaluator.length == 0 && !evaluatorTagged
													? 'error'
													: ''
											"
											class="qb-dropdown-diffy d-flex justify-content-between pointer"
											@click="
												(evaluatorSelect = !evaluatorSelect),
													(evalSearch = null)
											"
										>
											<span v-if="selevaluator.length == 0"
												>Select Evaluators</span
											>
											<span v-if="selevaluator.length == 1">
												{{ selectedGroup.evaluator.length }} Evaluator selected
											</span>
											<span v-if="selevaluator.length > 1"
												>{{ selectedGroup.evaluator.length }} Evaluators
												selected</span
											>

											<span>
												<img
													v-if="evaluatorSelect"
													src="../../assets/uparrow.svg"
													alt=""
													class="mr-1"
												/>
												<img
													v-else
													src="../../assets/downarrow.svg"
													alt=""
													class="mr-1"
												/>
											</span>
										</div>
										<div
											style="position: absolute; top: 5px; right: 35px"
											v-if="selectedGroup.evaluator == 0 && !evaluatorTagged"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											v-if="evaluatorSelect"
											class="swp-qb-dropdown-option-add w-100 widoption sharemailbtns"
										>
											<div class="groupshare-searchicon">
												<img src="../../assets/searchicon.svg" alt="" />
											</div>
											<b-form-input
												type="search"
												v-model="evalSearch"
												placeholder="Search Evaluator"
												class="groupshare-seachinput"
											></b-form-input>
											<div class="swp-groupOptionsDivUpadte p-1 pointer">
												<div class="swp-checkboxcontainer w-100">
													<div
														class="p-2 swp-jdTypeCheck text-truncate wordbreak"
														v-for="(data, i) in evalOptionSearch"
														:key="i"
													>
														<b-form-checkbox
															v-model="selectedGroup.evaluator"
															:value="data"
															@change="checkEvaluatorValidation"
															class="sec-checboxtext swp-check-email mr-2"
														>
															{{ data.name }}
														</b-form-checkbox>
													</div>
												</div>
												<div
													v-if="evalOptionSearch.length == 0"
													class="noSearchResultsText"
												>
													No results found for "{{ evalSearch }}" evaluator
												</div>
											</div>
										</div>
									</div>
									<div
										class="overflow-auto"
										:style="
											selectedGroup.evaluator.length >= 8
												? 'height: calc(40vh - 140px);padding-right: 10px;'
												: 'height:auto'
										"
									>
										<div
											v-for="(data, i) in selectedGroup.evaluator"
											:key="i"
											class="d-flex align-items-center justify-content-between mt-3"
										>
											<div class="d-flex align-items-center">
												<div>
													<img src="../../assets/orangeProfile.svg" alt="" />
												</div>
												<div class="ml-2 shareview-details-email mr-2">
													{{ data.email }}
												</div>
											</div>
											<span
												><img
													v-b-popover.hover="'Remove'"
													@click="removeEvaluator(i)"
													src="../../assets/icons/Reports/removeEmail.svg"
													alt=""
													class="mt-1 pointer"
											/></span>
										</div>
									</div>
								</div>
							</div>
							<div
								class="swp-left-card p-3 mt-2"
								v-if="selectedGroup.shareLink == null"
							>
								<div
									class="d-flex align-items-center justify-content-between"
									:class="selectedGroup.shareLink == null ? '' : 'mb-2'"
								>
									<div class="pr-tp-testhead">Assessment Link</div>

									<span
										class="pointer d-flex align-items-center"
										v-if="selectedGroup.shareLink == null"
										@click="
											selectedGroup.configured == false ||
											selectedGroup.open == 'False' ||
											(evaluatorTagged == false &&
												selectedGroup.evaluator.length == 0)
												? ''
												: generatelink(selectedGroup.groupID)
										"
										v-b-tooltip.hover="{ variant: 'secondary' }"
										:title="
											evaluatorTagged == false &&
											selectedGroup.evaluator.length == 0
												? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Generate Link'
												: selectedGroup.configured == false
												? 'Tag Configuration To Generate Link'
												: selectedGroup.open == 'False'
												? 'Tag Active Configuration To Generate Link'
												: ''
										"
									>
										<span>
											<img
												src="../../assets/generate link icon.svg"
												alt=""
												v-if="
													selectedGroup.configured == false ||
														selectedGroup.open == 'False' ||
														(evaluatorTagged == false &&
															selectedGroup.evaluator.length == 0)
												"
											/>
											<img
												v-else
												src="../../assets/icons/Reports/enableupdate.svg"
												alt=""
											/>
										</span>
										<span
											:class="
												selectedGroup.configured == false ||
												selectedGroup.open == 'False' ||
												(evaluatorTagged == false &&
													selectedGroup.evaluator.length == 0)
													? 'disablesharetext'
													: ''
											"
										>
											<span
												:class="
													selectedGroup.configured == false ||
													selectedGroup.open == 'False' ||
													(evaluatorTagged == false &&
														selectedGroup.evaluator.length == 0)
														? 'disablesharetext'
														: 'generateLink'
												"
											>
												Generate Link
											</span>
										</span>
									</span>
								</div>
							</div>
							<div
								v-if="selectedGroup.shareLink != null"
								class="swp-left-card-Assessment-Link p-3 mt-2"
							>
								<div class="d-flex align-items-center justify-content-between">
									<div class="pr-tp-testhead">Assessment Link</div>
								</div>
								<div class="p-1 mt-2">
									<div
										class="d-flex align-items-center justify-content-between mb-2"
									>
										<div class="swp-activetext">Current Link</div>
										<div class="d-flex align-items-center">
											<div
												class="d-flex align-items-center justify-content-between pointer"
											>
												<div class="pointer">
													<span
														v-b-tooltip.hover="{ variant: 'secondary' }"
														:title="
															evaluatorTagged == false && evaluatorLength == 0
																? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Update Link'
																: selectedGroup.open == 'False'
																? 'Tag Active Configuration To Update Link'
																: ''
														"
														:class="
															(evaluatorTagged == false &&
																evaluatorLength == 0) ||
															selectedGroup.open == 'False'
																? 'disablesharetext'
																: ''
														"
													>
														<img
															src="../../assets/generate link icon.svg"
															alt=""
															v-if="
																(evaluatorTagged == false &&
																	evaluatorLength == 0) ||
																	selectedGroup.open == 'False'
															"
														/><img
															v-else
															src="../../assets/update-arrows-svgrepo-com 1refresh.svg"
															alt=""
															@click="
																(updatelink = true),
																	generatelink(selectedGroup.groupID)
															"
														/>
														<span
															v-if="
																(evaluatorTagged == false &&
																	evaluatorLength == 0) ||
																	selectedGroup.open == 'False'
															"
														>
															Update Link
														</span>

														<span
															v-else
															class="updateLink"
															@click="
																(updatelink = true),
																	generatelink(selectedGroup.groupID)
															"
															>Update Link</span
														>
													</span>
												</div>
											</div>
											<div class="ml-3 pointer">
												<div class="ml-3">
													<div
														v-if="
															selectedGroup.shareLink == null ||
																selectedGroup.open == 'False' ||
																(evaluatorTagged == false &&
																	selectedGroup.evaluator.length == 0)
														"
														v-b-tooltip.hover="{ variant: 'secondary' }"
														:title="
															evaluatorTagged == false &&
															selectedGroup.evaluator.length == 0
																? 'Tag Evaluator Since It Has Non AutoCorrected Questions To Share Link'
																: selectedGroup.configured == false
																? 'Tag Configuration To Share Link'
																: selectedGroup.open == 'False'
																? 'Tag Active Configuration To Share Link'
																: 'share link'
														"
													>
														<img
															src="../../assets/icons/Reports/disableshareicon.svg"
															alt=""
														/>

														<span class="disablesharetext">Share link </span>
													</div>

													<div
														v-else
														v-b-popover.hover.top="'Share Link'"
														@click="shareLink(selectedGroup.groupID)"
													>
														<img
															src="../../assets/icons/Reports/enableshareicon.svg"
															alt=""
														/>
														<span class="swp-share-link-text ml-1"
															>Share link
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div></div>
									<div class="swp-textarea swp-link-text p-2">
										{{ selectedGroup.shareLink }}
									</div>
									<div v-if="selectedGroup.prevLinks.length !== 0">
										<hr />
										<div class="shareview-details-email">Previous Link</div>
										<div
											class="overflow-auto"
											:style="
												selectedGroup.prevLinks.length >= 2
													? 'max-height: calc(40vh - 189px);min-height:auto;padding-right:5px'
													: 'height:auto'
											"
										>
											<div
												v-for="(data, i) in selectedGroup.prevLinks"
												:key="i"
												style="opacity: 0.9"
											>
												<div class="swp-textarea swp-link-text p-2 mt-1">
													{{ data }}
												</div>
											</div>
											<div></div>
										</div>
									</div>
								</div>
							</div>
							<div class="swp-left-card p-3 mt-2">
								<div class="d-flex align-items-center justify-content-between">
									<div class="pr-tp-testhead">Configure</div>
									<div
										class="d-flex align-items-center justify-content-between"
									>
										<div>
											<div class="mr-3">
												<span
													v-if="selectedGroup.configured == false"
													class="deliveredtext"
													>Add Configuration</span
												>

												<span
													v-else-if="selectedGroup.open == 'False'"
													class="expiredClass"
													>Expired</span
												>
												<span
													v-else
													class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center mr-3"
													>Active</span
												>
											</div>
										</div>
										<div
											class="pointer"
											v-if="roles.includes(roledata.getconfig)"
										>
											<img
												v-if="selectedGroup.configured == false"
												v-b-popover.hover.top="'Add Configuration'"
												src="../../assets/icons/Reports/notConfigured.svg"
												alt=""
												@click="goToConfigure(selectedGroup)"
											/>
											<img
												v-else
												v-b-popover.hover.top="'Configure'"
												src="../../assets/icons/Reports/enableconfigicon.svg"
												alt=""
												@click="goToConfigure(selectedGroup)"
											/>
										</div>
									</div>
								</div>
								<div
									class="swp-greyBackground p-2 mt-3"
									v-if="selectedGroup.configured == true"
								>
									<div class="answertext">
										Configuration Name : {{ selectedGroup.configName }}
									</div>
								</div>
							</div>
							<b-row
								class="access-switch swp-left-card p-3 mt-3  mx-0 flex-column flex-nowrap"
							>
								<div class="d-flex align-items-baseline">
									<span class="fw-500 fs-16 color-black mr-2">Set Pricing</span>
									<b-form-checkbox
										switch
										v-model="setPricing"
										@change="hideshowPricingDetails"
									/>
								</div>

								<hr class="my-2 w-100" />

								<div class="d-flex align-items-center">
									<b-col class="pl-0">
										<div class="topDiv mt-3">
											<label class="fieldsetStyle" v-if="setPricing"
												>List Price(Rs.) &nbsp;<span class="asterik"
													>*</span
												></label
											>
											<b-form-input
												class="viewcon-inputField"
												placeholder="Enter here"
												v-model.number="$v.listPrice.$model"
												:class="{ error: $v.listPrice.$error }"
												:disabled="!setPricing"
												type="number"
											></b-form-input>
											<div
												style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
												v-if="$v.listPrice.$dirty && !$v.listPrice.required"
												v-b-popover.hover.top.v-danger="{
													content: 'Required',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>

											<div
												style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
												v-if="$v.listPrice.$dirty && !$v.listPrice.between"
												v-b-popover.hover.top.v-danger="{
													content: 'Must be between 0 and 100000',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
												v-if="
													$v.listPrice.$dirty && !$v.listPrice.maxFiveDecimals
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Must have at most 5 decimal places',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
									</b-col>
									<b-col class="pr-0">
										<div class="topDiv mt-3">
											<label class="fieldsetStyle" v-if="setPricing"
												>Discount(Rs.) &nbsp;</label
											>
											<b-form-input
												class="viewcon-inputField"
												placeholder="Enter here"
												v-model.number="$v.discount.$model"
												:class="{ error: $v.discount.$error }"
												:disabled="!setPricing"
												type="number"
											></b-form-input>
											<div
												style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
												v-if="!$v.discount.minValue"
												v-b-popover.hover.top.v-danger="{
													content: 'Discount Price Cannot be negative number',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
												v-if="
													$v.discount.$dirty && !$v.discount.notGreaterThanList
												"
												v-b-popover.hover.top.v-danger="{
													content:
														'Discount price cannot exceed or be equal than list price',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
												v-if="
													$v.discount.$dirty && !$v.discount.maxFiveDecimals
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Must have at most 5 decimal places',
												}"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
									</b-col>
								</div>
								<section class="mt-2" v-if="setPricing">
									<div
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead">List Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												₹{{ listPrice }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead">Discount Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												₹{{ discount }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead">Final Price</div>
										<div class="d-flex justify-content-end" style="width: 60%">
											<div class="swp-main-text text-truncate">
												₹{{ priceAfterDiscount }}
											</div>
										</div>
									</div>
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="pr-tp-testhead w-75">
											Payment Gateway Charges
										</div>
										<div class="d-flex justify-content-end">
											<div class="swp-main-text text-truncate">
												{{ gatewayPercent }}%
											</div>
										</div>
									</div>
									<hr class="my-2" />
									<div
										class="d-flex align-items-center justify-content-between mt-2"
									>
										<div class="pr-tp-testhead fw-500 color-333333 w-75">
											Final Amount Receivable
										</div>
										<div class="d-flex justify-content-end">
											<div class="swp-main-text fw-600 color-333333">
												₹{{ finalReceivable }}
											</div>
										</div>
									</div>
								</section>
							</b-row>
						</div>
					</div>
				</div>
				<div class="swp-group-detail-footer d-flex justify-content-end p-3">
					<div>
						<b-button
							class="cancel-btn mr-4"
							squared
							variant="outline"
							@click="editIndividual = false"
							>Cancel</b-button
						>
						<b-button
							variant="secondary"
							class="add-btn"
							@click="updateIndividual()"
							>Update</b-button
						>
					</div>
				</div>
			</div>
		</Transition>

		<!-- ***************         CREATE GROUP             ******************** -->
		<Transition name="slide">
			<div
				v-if="grptype == 'create' && grpcontainer"
				class="swp-group-detail-half-container"
			>
				<div class="d-flex align-items-center position-relative pt-2 pl-3">
					<div
						@click="
							(grpcontainer = false), (candidateTypeData = 'ng'), cancelThis()
						"
						class="position-absolute swp-backArrow pointer"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">Create Group</div>
				</div>
				<hr />
				<div class="swp-double-overflow">
					<div class="d-flex pl-3 pb-1 pt-2">
						<b-form-radio-group
							:options="candidateTypesData"
							v-model="candidateTypeData"
							value-field="item"
							text-field="name"
							disabled-field="notEnabled"
							size="sm"
						></b-form-radio-group>
					</div>
					<div class="pl-3 pr-3" v-if="candidateTypeData == 'ng'">
						<div class="swp-main-text mt-3">New Group</div>

						<div class="relativeclass swp-blueborder mt-4">
							<label class="fieldsetStyle"
								>Group Name &nbsp;<span class="asterik">*</span></label
							>
							<b-form-input
								class="defaultCursor"
								id="input-1"
								placeholder="Enter Group Name"
								v-model.trim="selectedGroup.groupName"
								:class="{ error: $v.selectedGroup.groupName.$error }"
							>
							</b-form-input>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									$v.selectedGroup.groupName.$dirty &&
										!$v.selectedGroup.groupName.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									!$v.selectedGroup.groupName.maxLength &&
										$v.selectedGroup.groupName.required
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 128 characters',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>

						<div
							class="topDiv position-relative mt-4"
							v-closable="{
								exclude: ['expdropdownGroup'],
								handler: 'hideexpertiseoptionsEditGroup',
							}"
						>
							<label class="fieldsetStyle sharelabel"
								>Select Evaluators<span v-if="!evaluatorTagged" class="asterik"
									>*</span
								></label
							>
							<div
								:class="
									selectedGroup.evaluator.length == 0 &&
									checkEval &&
									!evaluatorTagged
										? 'error'
										: ''
								"
								class="qb-dropdown-diffy d-flex justify-content-between pointer"
								@click="
									(evaluatorSelect = !evaluatorSelect), (evalSearch = null)
								"
							>
								<span v-if="selectedGroup.evaluator.length == 0"
									>Select Evaluators</span
								>
								<span v-if="selectedGroup.evaluator.length == 1">
									{{ selectedGroup.evaluator.length }} Evaluator selected
								</span>
								<span v-if="selectedGroup.evaluator.length > 1"
									>{{ selectedGroup.evaluator.length }} Evaluators
									selected</span
								>

								<span>
									<img
										v-if="evaluatorSelect"
										src="../../assets/uparrow.svg"
										alt=""
										class="mr-1"
									/>
									<img
										v-else
										src="../../assets/downarrow.svg"
										alt=""
										class="mr-1"
									/>
								</span>
							</div>
							<div
								style="position: absolute; top: 5px; right: 35px"
								v-if="
									selectedGroup.evaluator.length == 0 &&
										checkEval &&
										!evaluatorTagged
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								v-if="evaluatorSelect"
								class="swp-qb-dropdown-option-add w-100 widoption sharemailbtns"
							>
								<div class="groupshare-searchicon">
									<img src="../../assets/searchicon.svg" alt="" />
								</div>
								<b-form-input
									type="search"
									v-model="evalSearch"
									placeholder="Search Evaluator"
									class="groupshare-seachinput"
								></b-form-input>
								<div class="swp-groupOptionsDivUpadte p-1 pointer">
									<div class="swp-checkboxcontainer">
										<div
											class="p-2 swp-jdTypeCheck wordbreak"
											v-for="(evaluator, i) in evalOptionSearch"
											:key="i"
										>
											<b-form-checkbox
												v-model="selectedGroup.evaluator"
												:value="evaluator"
												@change="evalUpdate()"
												class="sec-checboxtext swp-check-email mr-2"
											>
												{{ evaluator.name }}
											</b-form-checkbox>
										</div>
										<div
											v-if="evalOptionSearch.length == 0"
											class="noSearchResultsText"
										>
											No results found for "{{ evalSearch }}" evaluator
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="topDiv mt-30" ref="dropdownmailids">
							<div v-b-modal.excel-modal class="clearfilter import-excel-pos">
								Import excel
							</div>
							<div class="mt-3 pointer" @click="toggleDropdownmailids">
								<b-form-tags
									v-model="selectedGroup.candidates"
									no-outer-focus
									separator=" ,;"
									class="mb-2 groupshare-formtag"
								>
									<template v-slot="{ inputAttrs }">
										<b-input-group aria-controls="my-custom-tags-list">
											<label class="fieldsetStyle"
												>Email &nbsp;<span class="asterik">*</span></label
											>
											<b-form-input
												v-bind="inputAttrs"
												v-on:keyup.enter="customHandler"
												@keyup="mailids = true"
												@input="convertAaddIndividual()"
												placeholder="New email - Enter or Search To Add"
												class="form-control swp-drop pointer"
												style="border-radius: 3px"
												v-model.trim="$v.addIndividualEmail.$model"
												:class="
													$v.addIndividualEmail.$error ||
													emailSelectedEmpty ||
													groupLengthError
														? 'error'
														: ''
												"
											></b-form-input>
											<div
												style="position: absolute; top: 5px; right: 35px"
												v-if="
													$v.addIndividualEmail.$dirty &&
														!$v.addIndividualEmail.required
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 5px; right: 35px"
												v-if="emailSelectedEmpty || groupLengthError"
												v-b-popover.hover.top.v-danger="{
													content: 'Two or more candidates required',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 5px; right: 35px"
												v-if="
													!$v.addIndividualEmail.alpha ||
														($v.addIndividualEmail.required &&
															!$v.addIndividualEmail.email)
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Invalid email address',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>

											<b-input-group-append class="addtaginput pointer">
												<b-button
													@click="customAdd(inputAttrs)"
													variant="outline"
													class="cursor-pointer p-2"
												>
													<img src="../../assets/addicongraywhite.svg" alt="" />
												</b-button>
											</b-input-group-append>
										</b-input-group>
									</template>
								</b-form-tags>
							</div>
							<div
								v-if="mailids && optionssearch.length > 0"
								class="pointer w-100 swp-grp-sec-modal groupOptionsDiv sharemailbtns"
							>
								<div>
									<div
										v-for="(i, index) in optionssearch"
										:key="index"
										style="display: grid"
										class="p-2 swp-jdTypeCheck wordbreak"
									>
										<b-form-checkbox
											class="sec-checboxtext swp-check-email mr-2"
											v-model="selectedGroup.candidates"
											:value="i.groupName"
											@change="changeEmptyEmail"
										>
											{{ i.groupName }}
										</b-form-checkbox>
									</div>
								</div>
							</div>
						</div>

						<div class="swp-overflow-can-eval-2">
							<div
								class="swp-left-card-height-create-gc p-3 mt-2"
								v-if="selectedGroup.candidates.length != 0"
							>
								<div class="d-flex align-items-center">
									<div>
										<img
											src="../../assets/icons/Reports/grouppeople.svg"
											alt=""
										/>
									</div>
									<div class="swp-main-text ml-2">Group Candidates</div>
								</div>

								<hr />
								<div
									class="overflow-auto"
									:style="
										selectedGroup.candidates.length >= 8
											? 'height: calc(40vh - 90px)'
											: 'height: auto'
									"
								>
									<div
										v-for="(data, i) in selectedGroup.candidates"
										:key="i"
										class="d-flex align-items-center justify-content-between p-1"
									>
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/orangeProfile.svg" alt="" />
											</div>
											<div class="ml-2 shareview-details-email mr-2">
												{{ data }}
											</div>
										</div>
										<span
											><img
												@click="removeSelectedEmail(i)"
												src="../../assets/icons/Reports/removeEmail.svg"
												alt=""
												class="mt-1 pointer"
										/></span>
									</div>
								</div>
							</div>

							<div
								class="swp-left-card-height-create-g p-3 mt-4"
								v-if="selectedGroup.evaluator.length != 0"
							>
								<div class="d-flex align-items-center">
									<div>
										<img src="../../assets/greenEvaluator.svg" alt="" />
									</div>
									<div class="swp-main-text ml-2">Evaluators</div>
								</div>

								<hr />
								<div
									class="overflow-auto"
									:style="
										selectedGroup.evaluator.length >= 8
											? 'height: calc(40vh - 90px)'
											: 'height: auto'
									"
								>
									<div
										v-for="(data, i) in selectedGroup.evaluator"
										:key="i"
										class="d-flex align-items-center justify-content-between p-1"
									>
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/orangeProfile.svg" alt="" />
											</div>
											<div class="ml-2 shareview-details-email mr-2">
												{{ data.email }}
											</div>
										</div>
										<span
											><img
												v-b-popover.hover="'Remove'"
												@click="removeEvaluator(i)"
												src="../../assets/icons/Reports/removeEmail.svg"
												alt=""
												class="mt-1 pointer"
										/></span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="" v-if="candidateTypeData == 'sg'">
						<div class="pl-3 pr-3">
							<template>
								<div class="groupheading mt-3">Select Group</div>
								<div class="relativeclass" ref="expdropdownselectedGroup">
									<div
										class="relativeclass mt-4 pointer"
										@click="toggleDropdownselectedGroup"
									>
										<div class="fieldsetStyle swp-section-text">
											Select a Group <span class="asterik">*</span>
										</div>
										<div
											:class="
												selectedGroup.groupName == '' && checkGroup
													? 'error'
													: 'section-content-group'
											"
											class="section-content-group d-flex justify-content-between align-items-center"
										>
											<div
												class="sectionname"
												v-if="
													selectedGroup.groupName == '' ||
														creategroup == true ||
														selectedGroup == false
												"
											>
												Select a Group
											</div>
											<div class="sectionname" v-if="creategroup == false">
												{{ selectedGroup.groupName }}
											</div>

											<div>
												<img
													v-if="sectionmodal"
													src="../../assets/uparrow.svg"
													alt=""
												/>
												<img v-else src="../../assets/downarrow.svg" alt="" />
											</div>
										</div>
										<div
											style="position: absolute; top: 6px; right: 35px"
											v-if="selectedGroup.groupName == '' && checkGroup"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>

									<div
										v-if="sectionmodal"
										class="swp-section-modal sharemailbtns"
										style="top: 40px"
									>
										<div class="groupshare-searchicon" style="top: 8px">
											<img src="../../assets/searchicon.svg" alt="" />
										</div>
										<b-form-input
											type="search"
											v-model="groupSearch"
											placeholder="Search Group"
											class="groupshare-seachinput"
										></b-form-input>
										<div class="p-1">
											<div class="groupOptionsDiv pointer">
												<div
													v-for="(group, i) in groupOptionSearch"
													:key="i"
													style="display: grid"
													class="p-2 swp-jdTypeCheck swp-check-email wordbreak"
												>
													<b-form-checkbox
														v-model="selectedGroup"
														@change="
															(creategroup = false),
																(sectionmodal = false),
																(mailids = false);
															changeSelectedGroupCheck();
														"
														:value="{ ...group, evaluator: [] }"
													>
														{{ group.groupName }}
													</b-form-checkbox>
												</div>
												<div
													v-if="groupOptionSearch.length == 0"
													class="noSearchResultsText"
												>
													No results found for the group searched
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="relativeclass"
									ref="hideexpertiseoptionsEvalref"
									v-if="selectedGroup.groupName != ''"
								>
									<div
										class="relativeclass mt-3 pointer"
										@click="hideexpertiseoptionsEval"
									>
										<div class="swp-section-text fieldsetStyle">
											Select Evaluators
											<span v-if="!evaluatorTagged" class="asterik">*</span>
										</div>
										<div
											class="section-content-group d-flex justify-content-between align-items-center"
											:class="
												selectedGroup.evaluator.length == 0 &&
												checkEval &&
												!evaluatorTagged
													? 'error'
													: ''
											"
										>
											<div
												class="sectionname"
												v-if="selectedGroup.evaluator.length == 0"
											>
												Select Evaluators
											</div>
											<div
												class="sectionname"
												v-if="selectedGroup.evaluator.length == 1"
											>
												{{ selectedGroup.evaluator.length }} Evaluator selected
											</div>
											<div
												class="sectionname"
												v-if="selectedGroup.evaluator.length > 1"
											>
												{{ selectedGroup.evaluator.length }} Evaluators selected
											</div>

											<div>
												<img
													v-if="sectioneval"
													src="../../assets/uparrow.svg"
													alt=""
												/>
												<img v-else src="../../assets/downarrow.svg" alt="" />
											</div>
										</div>
									</div>
									<div
										style="position: absolute; top: 5px; right: 35px"
										v-if="
											selectedGroup.evaluator.length == 0 &&
												checkEval &&
												!evaluatorTagged
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
									<div
										v-if="sectioneval"
										class="swp-section-modal sharemailbtns"
										style="top: 40px"
									>
										<div class="groupshare-searchicon" style="top: 6px">
											<img src="../../assets/searchicon.svg" alt="" />
										</div>
										<b-form-input
											type="search"
											v-model="evalSearch"
											placeholder="Search Evaluator"
											class="groupshare-seachinput"
										></b-form-input>
										<div class="p-1">
											<div
												class="groupOptionsDivUpadte pill-content pointer w-100"
											>
												<div
													v-for="(evaluator, i) in evalOptionSearch"
													:key="i"
													style="display: grid"
													class="p-2 swp-jdTypeCheck swp-check-email text-truncate"
												>
													<b-form-checkbox
														v-model="selectedGroup.evaluator"
														:value="evaluator"
														@change="evalUpdate()"
													>
														{{ evaluator.name }}
													</b-form-checkbox>
												</div>
												<div
													v-if="evalOptionSearch.length == 0"
													class="noSearchResultsText"
												>
													No results found for "{{ evalSearch }}" evaluator
												</div>
											</div>
										</div>
									</div>
								</div>
							</template>
						</div>
						<div>
							<div
								class="swp-overflow-cand-eavl p-3"
								v-if="selectedGroup.candidates.length != 0"
							>
								<div class="swp-left-card-height-select-g p-3">
									<div class="d-flex align-items-center">
										<div>
											<img
												src="../../assets/icons/Reports/grouppeople.svg"
												alt=""
											/>
										</div>
										<div class="swp-main-text ml-2">Group Candidates</div>
									</div>

									<hr />
									<div
										class="overflow-auto"
										:style="
											selectedGroup.candidates.length >= 5
												? 'max-height: calc(40vh - 90px);min-height:auto;padding-right:5px'
												: 'height: auto'
										"
									>
										<div
											v-for="(candidate, index) in selectedGroup.candidates"
											:key="index"
											class="d-flex justify-content-between p-1"
										>
											<div class="d-flex">
												<div>
													<img src="../../assets/orangeProfile.svg" alt="" />
												</div>
												<div class="ml-2 shareview-details-email mr-2">
													{{ candidate }}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div
									class="swp-left-card-height-select-g p-3 mt-4"
									v-if="selectedGroup.evaluator.length != 0"
								>
									<div class="d-flex align-items-center">
										<div>
											<img src="../../assets/greenEvaluator.svg" alt="" />
										</div>
										<div class="swp-main-text ml-2">Evaluators</div>
									</div>

									<hr />
									<div
										class="overflow-auto"
										:style="
											selectedGroup.evaluator.length >= 8
												? 'height: calc(40vh - 120px)'
												: 'height: auto'
										"
									>
										<div
											v-for="(candidate, evalindex) in selectedGroup.evaluator"
											:key="evalindex"
											class="d-flex align-items-center justify-content-between p-1"
										>
											<div class="d-flex align-items-center">
												<div>
													<img src="../../assets/orangeProfile.svg" alt="" />
												</div>
												<div class="ml-2 shareview-details-email mr-2">
													{{ candidate.name }}
													<!-- abc@gmail.com -->
												</div>
											</div>
											<span
												><img
													v-b-popover.hover="'Remove'"
													@click="removeEvaluator(evalindex)"
													src="../../assets/icons/Reports/removeEmail.svg"
													alt=""
													class="mt-1 pointer"
											/></span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="pricing-container mt-3" style="margin: 0 15px;">
						<b-row class="access-switch  flex-column px-3">
							<div class="d-flex align-items-baseline ">
								<span class="fw-500 fs-16 color-black mr-2">Set Pricing</span>
								<b-form-checkbox
									name="role-check-button"
									class=""
									switch
									v-model="setPricing"
									@change="hideshowPricingDetails"
								>
								</b-form-checkbox>
							</div>
							<hr style="border-top:1px solid #D0D5DD80;" class="my-2 w-100" />
							<div class="d-flex align-items-center position-relative">
								<b-col class="pl-0">
									<div class="topDiv mt-3">
										<label class="fieldsetStyle" v-if="setPricing"
											>List Price(Rs.) &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="Enter here"
											v-model.number="$v.listPrice.$model"
											:class="{ error: $v.listPrice.$error }"
											:disabled="!setPricing"
											type="number"
										></b-form-input>
										<div
											style="
						position: absolute;
						top: 4px;
						right: 12px;
						background: var(--bg-white);
					  "
											v-if="$v.listPrice.$dirty && !$v.listPrice.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="
						position: absolute;
						top: 4px;
						right: 12px;
						background: var(--bg-white);
					  "
											v-if="$v.listPrice.$dirty && !$v.listPrice.between"
											v-b-popover.hover.top.v-danger="{
												content: 'Must be between 0 and 100000',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="
												$v.listPrice.$dirty && !$v.listPrice.maxFiveDecimals
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col class="pr-0">
									<div class="topDiv mt-3">
										<label class="fieldsetStyle" v-if="setPricing"
											>Discount(Rs.) &nbsp;</label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="Enter here"
											v-model.number="$v.discount.$model"
											:class="{ error: $v.discount.$error }"
											:disabled="!setPricing"
											type="number"
										></b-form-input>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="!$v.discount.minValue"
											v-b-popover.hover.top.v-danger="{
												content: 'Discount Price Cannot be negative number',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="
						position: absolute;
						top: 4px;
						right: 12px;
						background: var(--bg-white);
					  "
											v-if="
												$v.discount.$dirty && !$v.discount.notGreaterThanList
											"
											v-b-popover.hover.top.v-danger="{
												content:
													'Discount cannot exceed or be equal than list price',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
											v-if="$v.discount.$dirty && !$v.discount.maxFiveDecimals"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<div
									style="  position: absolute;
						 top: 60px;
						 left: 3px;
					 "
									class="fw-500 fs-10 color-7a7a7a fam-lato position-absolute"
								>
									Discount Price should be lesser than List price
								</div>
							</div>
						</b-row>
						<template v-if="setPricing">
							<section class="mt-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="fw-500 font-lato fs-14 color-344054">
										List Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ listPrice || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Discount
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ discount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Final Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ priceAfterDiscount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054 w-75">
										Payment Gateway Charges
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										{{ gatewayPercent }}%
									</div>
								</div>
							</section>
							<hr />
							<div
								class="d-flex align-items-center justify-content-between mt-1"
							>
								<div class="fw-600 font-lato fs-14 color-333333 w-75">
									Final Amount Receivable
								</div>
								<div class="fw-700 font-mont fs-16 color-333333">
									₹{{ finalReceivable || 0 }}
								</div>
							</div>
						</template>
					</div>
				</div>
				<div class="swp-group-detail-footer d-flex justify-content-end p-3">
					<div class="d-flex align-items-center">
						<div
							@click="grpcontainer = false"
							class="swp-cancelbtntext pointer"
						>
							Cancel
						</div>
						<b-button
							@click="
								candidateTypeData == 'ng' ? createGroup() : addSelectedGroup()
							"
							class="ml-2 swp-addbtn pointer"
						>
							Add
						</b-button>
					</div>
				</div>
			</div>
		</Transition>

		<!-- ***************         CREATE INDIVIDUAL             ******************** -->
		<Transition name="slide">
			<div
				v-if="grptype == 'individual' && grpcontainer"
				class="swp-group-detail-half-container"
			>
				<div class="position-relative d-flex align-items-center pt-2 pl-3">
					<div
						@click="(grpcontainer = false), cancelThis()"
						class="position-absolute swp-backArrow pointer"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">Add Individual</div>
				</div>
				<hr />
				<section style="height: calc(100vh - 220px); overflow-y: auto">
					<template>
						<div class="p-3">
							<div class="relativeclass swp-blueborder" ref="dropdown">
								<div class="topDiv mt-1">
									<label class="fieldsetStyle"
										>Email &nbsp;<span class="asterik">*</span></label
									>
									<b-form-input
										class="defaultCursor"
										id="input-2"
										@click="toggleDropdown"
										@input="
											(individualmail = true),
												changeSelectedEmailCheck(),
												convertToLowerCase(),
												(putapi = false)
										"
										v-model="individualCandidate"
										placeholder="Enter Email ID"
										type="text"
										:class="{ error: $v.individualCandidate.$error }"
										v-on:keyup.enter="saveIndividual"
									>
									</b-form-input>

									<div
										style="position: absolute; top: 5px; right: 12px"
										v-if="
											$v.individualCandidate.$dirty &&
												!$v.individualCandidate.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>

									<div
										style="position: absolute; top: 5px; right: 12px"
										v-if="
											!$v.individualCandidate.alpha ||
												($v.individualCandidate.required &&
													!$v.individualCandidate.email)
										"
										v-b-popover.hover.top.v-danger="{
											content: 'Invalid email address',
										}"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
								<div
									v-if="individualmail && individualemailsearch.length > 0"
									class="sh-grp-sec-modal sharemailbtns p-0"
								>
									<div class="groupshare-searchicon" style="top: 7px">
										<img src="../../assets/searchicon.svg" alt="" />
									</div>
									<b-form-input
										v-model="individualCandidateEmailSearch"
										@keyup="putapi = true"
										type="search"
										placeholder="Search Individual email"
										class="groupshare-seachinput"
									></b-form-input>
									<div class="p-1">
										<b-overlay :show="showLoader" rounded="sm">
											<div class="groupOptionsDiv">
												<div
													v-for="(i, index) in individualemailsearchList"
													:key="index"
													style="display: grid"
													class="p-2 swp-jdTypeCheck pointer wordbreak"
												>
													<b-form-checkbox
														class="sec-checboxtext swp-check-email swp-check-email-individualmail mr-2 pointer"
														v-model="individualCandidate"
														:value="i.groupName"
														@change="(individualmail = false), indCandChange(i)"
														style="margin-left: -18px"
													>
														{{ i.groupName }}
													</b-form-checkbox>
												</div>
												<div
													v-if="individualemailsearchList.length == 0"
													class="noSearchResultsText"
												>
													No results found for the Individual email searched
												</div>
											</div>
										</b-overlay>
									</div>
								</div>
							</div>

							<div
								class="topDiv position-relative mt-4 expdropdownIndividual"
								v-closable="{
									exclude: ['expdropdownIndividual'],
									handler: 'hideexpertiseoptionsIndividual',
								}"
							>
								<label class="fieldsetStyle sharelabel"
									>Select Evaluators<span
										v-if="!evaluatorTagged"
										class="asterik"
										>*</span
									></label
								>
								<div
									:class="
										selevaluator.length == 0 && checkEval && !evaluatorTagged
											? 'error'
											: ''
									"
									class="qb-dropdown-diffy d-flex justify-content-between pointer"
									@click="
										(evaluatorSelect = !evaluatorSelect), (evalSearch = null)
									"
								>
									<span v-if="selevaluator.length == 0">Select Evaluators</span>
									<span v-if="selevaluator.length == 1">
										{{ selevaluator.length }} Evaluator selected
									</span>
									<span v-if="selevaluator.length > 1"
										>{{ selevaluator.length }} Evaluators selected</span
									>

									<span>
										<img
											v-if="evaluatorSelect"
											src="../../assets/uparrow.svg"
											alt=""
											class="mr-1"
										/>
										<img
											v-else
											src="../../assets/downarrow.svg"
											alt=""
											class="mr-1"
										/>
									</span>
								</div>
								<div
									style="position: absolute; top: 5px; right: 35px"
									v-if="
										selevaluator.length == 0 && checkEval && !evaluatorTagged
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									v-if="evaluatorSelect"
									class="swp-qb-dropdown-option-add w-100 widoption sharemailbtns"
								>
									<div class="groupshare-searchicon">
										<img src="../../assets/searchicon.svg" alt="" />
									</div>
									<b-form-input
										type="search"
										v-model="evalSearch"
										placeholder="Search Evaluator"
										class="groupshare-seachinput"
									></b-form-input>
									<div class="swp-groupOptionsDivUpadte p-1 pointer">
										<div class="swp-checkboxcontainer pointer">
											<div
												class="p-2 swp-jdTypeCheck pointer wordbreak"
												v-for="(data, i) in evalOptionSearch"
												:key="i"
											>
												<b-form-checkbox
													size="sm"
													v-model="selevaluator"
													:value="data"
													class="sec-checboxtext swp-check-email mr-2 pointer"
												>
													{{ data.name }}
												</b-form-checkbox>
											</div>
											<div
												v-if="evalOptionSearch.length == 0"
												class="noSearchResultsText text-break"
											>
												No results found for "{{ evalSearch }}" evaluator
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="pricing-container mt-3">
								<b-row class="access-switch mx-0 flex-column position-relative">
									<div class="d-flex align-items-baseline ">
										<span class="fw-500 fs-16 color-black mr-2"
											>Set Pricing</span
										>
										<b-form-checkbox
											name="role-check-button"
											class=""
											switch
											v-model="setPricing"
											@change="hideshowPricingDetails"
										>
										</b-form-checkbox>
									</div>
									<hr
										style="border-top:1px solid #D0D5DD80;"
										class="my-2 w-100"
									/>
									<div class="d-flex align-items-center">
										<b-col class="pl-0">
											<div class="topDiv mt-3">
												<label class="fieldsetStyle" v-if="setPricing"
													>List Price(Rs.) &nbsp;<span class="asterik"
														>*</span
													></label
												>
												<b-form-input
													class="viewcon-inputField"
													placeholder="Enter here"
													v-model.number="$v.listPrice.$model"
													:class="{ error: $v.listPrice.$error }"
													:disabled="!setPricing"
													type="number"
												></b-form-input>
												<div
													style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
													v-if="$v.listPrice.$dirty && !$v.listPrice.required"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>

												<div
													style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
													v-if="$v.listPrice.$dirty && !$v.listPrice.between"
													v-b-popover.hover.top.v-danger="{
														content: 'Must be between 0 and 100000',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
													v-if="
														$v.listPrice.$dirty && !$v.listPrice.maxFiveDecimals
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Must have at most 5 decimal places',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
											</div>
										</b-col>
										<b-col class="pr-0">
											<div class="topDiv mt-3">
												<label class="fieldsetStyle" v-if="setPricing"
													>Discount(Rs.) &nbsp;</label
												>
												<b-form-input
													class="viewcon-inputField"
													placeholder="Enter here"
													v-model.number="$v.discount.$model"
													:class="{ error: $v.discount.$error }"
													:disabled="!setPricing"
													type="number"
												></b-form-input>
												<div
													style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
													v-if="!$v.discount.minValue"
													v-b-popover.hover.top.v-danger="{
														content: 'Discount Price Cannot be negative number',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="
                    position: absolute;
                    top: 4px;
                    right: 12px;
                    background: var(--bg-white);
                  "
													v-if="
														$v.discount.$dirty &&
															!$v.discount.notGreaterThanList
													"
													v-b-popover.hover.top.v-danger="{
														content:
															'Discount cannot exceed or be equal than list price',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="
                  position: absolute;
                  top: 4px;
                  right: 12px;
                  background: var(--bg-white);
                "
													v-if="
														$v.discount.$dirty && !$v.discount.maxFiveDecimals
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Must have at most 5 decimal places',
													}"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
											</div>
										</b-col>
									</div>
									<div
										style="  position: absolute;
						 top: 99px;
						 left: 4px;
					 "
										class="fw-500 fs-10 color-7a7a7a fam-lato position-absolute"
									>
										Discount Price should be lesser than List price
									</div>
								</b-row>
								<template v-if="setPricing">
									<section class="mt-4">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="fw-500 font-lato fs-14 color-344054">
												List Price
											</div>
											<div class="fw-500 font-mont fs-15 color-333333">
												₹{{ listPrice || 0 }}
											</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between mt-1"
										>
											<div class="fw-500 font-lato fs-14 color-344054">
												Discount
											</div>
											<div class="fw-500 font-mont fs-15 color-333333">
												₹{{ discount || 0 }}
											</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between mt-1"
										>
											<div class="fw-500 font-lato fs-14 color-344054">
												Final Price
											</div>
											<div class="fw-500 font-mont fs-15 color-333333">
												₹{{ priceAfterDiscount || 0 }}
											</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between mt-1"
										>
											<div class="fw-500 font-lato fs-14 color-344054 w-75">
												Payment Gateway Charges
											</div>
											<div class="fw-500 font-mont fs-15 color-333333">
												{{ gatewayPercent }}%
											</div>
										</div>
									</section>
									<hr />
									<div
										class="d-flex align-items-center justify-content-between mt-1"
									>
										<div class="fw-600 font-lato fs-14 color-333333 w-75">
											Final Amount Receivable
										</div>
										<div class="fw-700 font-mont fs-16 color-333333">
											₹{{ finalReceivable || 0 }}
										</div>
									</div>
								</template>
							</div>
						</div>
						<div
							class="swp-addIndi_middle-container pl-3 pr-3"
							v-if="selevaluator.length != 0"
						>
							<div class="swp-left-card-height-ai p-3">
								<div class="d-flex align-items-center">
									<div>
										<img src="../../assets/greenEvaluator.svg" alt="" />
									</div>
									<div class="swp-main-text ml-2">Evaluators</div>
								</div>

								<hr />
								<div class="swp-left-card-height-overflow">
									<div
										v-for="(data, i) in selevaluator"
										:key="i"
										class="d-flex align-items-center justify-content-between p-1"
									>
										<div class="d-flex align-items-center">
											<div>
												<img src="../../assets/orangeProfile.svg" alt="" />
											</div>
											<div class="ml-2 shareview-details-email mr-2">
												{{ data.name }}
												<!-- abc@gmail.com -->
											</div>
										</div>
										<span
											><img
												v-b-popover.hover="'Remove'"
												@click="removeIndiEvaluator(i)"
												src="../../assets/icons/Reports/removeEmail.svg"
												alt=""
												class="mt-1 pointer"
										/></span>
									</div>
								</div>
							</div>
						</div>
					</template>
				</section>
				<div class="swp-group-detail-footer d-flex justify-content-end p-3">
					<div class="d-flex align-items-center">
						<div
							@click="grpcontainer = false"
							class="swp-cancelbtntext pointer"
						>
							Cancel
						</div>
						<b-button @click="saveIndividual()" class="ml-2 swp-addbtn pointer">
							Add
						</b-button>
					</div>
				</div>
			</div>
		</Transition>

		<b-modal
			id="modal-delete"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('modal-delete')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to delete ?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteGroup()">Delete</b-button>
			</div>
		</b-modal>
		<b-modal
			id="modal-confirm"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Alert !
			</div>
			<div @click="$bvModal.hide('modal-confirm')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span
					>Are you sure you want to
					<span
						>{{
							storeGroup.shareLink == null ? "generate link" : "update link"
						}}
					</span>
					?</span
				>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="linkGenerate()"
					><span>
						{{ storeGroup.shareLink == null ? "Generate Link" : "Update Link" }}
					</span></b-button
				>
			</div>
		</b-modal>
		<b-modal
			id="modal-shareLink"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Alert !
			</div>
			<div @click="$bvModal.hide('modal-shareLink')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span
					>Are you sure you want to
					<span
						>{{
							storeGroup.shareStatus == "unshared"
								? "share link"
								: "resend link"
						}}
					</span>
					?</span
				>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="linkShare()"
					><span>
						{{
							storeGroup.shareStatus == "unshared"
								? "Share Link"
								: "Resend Link"
						}}
					</span></b-button
				>
			</div>
		</b-modal>
		<!-- confirm message -->
		<b-modal
			id="confirm-modal"
			v-model="confirmModal"
			centered
			hide-footer
			hide-header
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution!
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('confirm-modal')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				There are Non AutoCorrected questions in this test, so make sure
				evaluators are tagged to all groups/individuals
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="confirmModal = false">Ok</b-button>
			</div>
		</b-modal>

		<b-modal
			id="confirm-modal-group-addForce"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div
				@click="$bvModal.hide('confirm-modal-group-addForce')"
				class="xMarkCancel"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3">
				{{ forceDataGroup }}
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button
					class="addbtn"
					@click="
						selectedGroup.candidateType == 'R' ||
						selectedGroup.candidateType == 'G'
							? ((force = true), addSelectedGroup())
							: ((force = true), saveIndividual())
					"
					>Add</b-button
				>
			</div>
		</b-modal>
		<b-modal
			id="modal-center"
			centered
			hide-footer
			hide-header
			@show="resetAddModal"
			@hidden="resetAddModal"
			no-stacking
			class="qb-eval-modal"
			no-close-on-backdrop
		>
			<div class="">
				<div @click="killTagEvaluator()" class="xMarkCancel">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				<div class="modalheading">Tag Evaluator</div>
				<div
					class="topDiv mt-4"
					:style="evaluatorSelect ? 'height: 305px' : ''"
				>
					<label class="fieldsetStyle sharelabel"
						>Select Evaluators<span class="asterik">*</span></label
					>
					<div
						class="qb-dropdown-diffy d-flex justify-content-between pointer"
						@click="evaluatorSelect = !evaluatorSelect"
					>
						<span v-if="selevaluator.length == 0">Select Evaluators</span>
						<span v-if="selevaluator.length == 1">
							{{ selevaluator.length }} Evaluator selected
						</span>
						<span v-if="selevaluator.length > 1"
							>{{ selevaluator.length }} Evaluators selected</span
						>
						<span>
							<img
								v-if="evaluatorSelect"
								src="../../assets/uparrow.svg"
								alt=""
								class="mr-1"
							/>
							<img
								v-else
								src="../../assets/downarrow.svg"
								alt=""
								class="mr-1"
							/>
						</span>
					</div>
					<div class="w-100 position-relative" v-if="evaluatorSelect">
						<div class="groupshare-searchicon">
							<img src="../../assets/searchicon.svg" alt="" />
						</div>
						<b-form-input
							type="search"
							v-model="evalSearch"
							placeholder="Search Evaluator"
							class="groupshare-seachinput"
						></b-form-input>
					</div>
					<div
						v-if="evaluatorSelect"
						class="w-100 sharemailbtns p-0 swp-tagEval-modal"
					>
						<div>
							<div
								v-for="(eval1, i) in evalOptionSearch"
								:key="i"
								style="display: grid"
							>
								<b-form-checkbox
									stacked
									button
									v-model="selevaluator"
									:value="eval1"
									class="w-100"
								>
									<img src="../../assets/icons/Reports/singlepep.svg" alt="" />
									<span v-if="eval1.name.toString().length > 40">
										{{ eval1.name.toString().slice(0, 40) + `...` }}
									</span>
									<span v-else>
										{{ eval1.name }}
									</span>
								</b-form-checkbox>
							</div>
							<div
								v-if="evalOptionSearch.length == 0"
								class="noSearchResultsText"
							>
								No results found for "{{ evalSearch }}" evaluator
							</div>
						</div>
					</div>
				</div>
			</div>
			<b-button
				class="addbtn mt-5"
				:disabled="selevaluator == ''"
				@click="evaluatorTag()"
			>
				<span class="pl-2 pr-2 pt-1 pb-1">Add</span>
			</b-button>
		</b-modal>
		<b-modal
			id="confirm-edit"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('confirm-edit')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to edit ?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				This group is tagged to more than one test. These changes will reflect
				in all other tests
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn mr-2" @click="confirm()">Confirm</b-button>
				<div class="sec-canceltext pointer" @click="cancel()">Cancel</div>
			</div>
		</b-modal>

		<!-- confirm message end -->
		<b-modal
			id="excel-modal"
			centered
			hide-footer
			hide-header
			@show="removeExcelFromPopUp"
			@hidden="removeExcelFromPopUp"
			class="qb-add-ques-modal"
			no-stacking
			no-close-on-backdrop
		>
			<div class="">
				<div class="">
					<div @click="$bvModal.hide('excel-modal')" class="xMarkCancel">
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<div class="modalheading">Import Excel</div>
					<div
						class="d-flex justify-content-center align-items-center mt-3 position-relative"
					>
						<input
							ref="excel-upload-input"
							class="excel-upload-input"
							type="file"
							accept=".xlsx, .xls"
							@change="handleClick"
						/>

						<b-button @click="handleUpload" class="addbtn mr-2 pl-2 pr-2">
							<img
								src="../../assets/icons/uploadexcel/uploadicon.svg"
								alt=""
								class="mr-2 mb-1"
							/>
							<span class="">Browse excel file here</span>
						</b-button>
						<div v-if="fileError" class="error-txt error-txt-pos">
							{{ fileError }}
						</div>
					</div>
				</div>

				<div class="uploadfile-container mt-3" v-if="excelFile != null">
					<div class="d-flex justify-content-between align-items-center mt-1">
						<div class="uploadfile-head-text">{{ excelFile.name }}</div>
						<div>
							<img
								src="../../assets/icons/uploadexcel/closeicon.svg"
								alt=""
								class="pointer"
								@click="removeExcelFile"
							/>
						</div>
					</div>
				</div>

				<div class="mt-4 d-flex justify-content-between">
					<div>
						<b-button
							variant="outline"
							class="cursor-pointer p-2"
							@click="getExcelTemplate()"
						>
							<span
								><img
									src="../../assets/icons/uploadexcel/downloadicon.svg"
									alt=""
							/></span>
							<span class="ml-2 qb-add-more-matches">Download Template</span>
						</b-button>
					</div>
					<div class="">
						<b-button
							variant="out-second view-feedbtn ml-1"
							squared
							@click="$bvModal.hide('excel-modal'), removeExcelFile()"
							>Cancel
						</b-button>
						<b-button
							:disabled="!Boolean(excelFile) || Boolean(fileError)"
							class="addbtn ml-3 pr-3 pl-3"
							@click="acceptExcel()"
							>Upload</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
let XLSX = require("xlsx");
import {
	postTaggedGroup,
	taggedGroup,
	postShareGroup,
	putShareGroup,
	generateLink,
	shareLink,
	deleteShareGroup,
	getEvalList,
	tagEvaluator,
	setPrevLink,
	postGroupExcel,
	getGroupTemplate,
	getGatewayCharges,
} from "../../utils/apiFunctions";
import successToast from "../mixin/toast.js";
import errorToast from "../mixin/toast";
import {
	required,
	email,
	requiredIf,
	helpers,
	maxLength,
	between,
	minValue,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
const maxFiveDecimals = helpers.withParams(
	{ type: "maxFiveDecimals" },
	(value) => {
		if (!helpers.req(value)) return true;

		const str = value.toString();
		if (!str.includes(".")) return true;

		return str.split(".")[1].length <= 5;
	}
);
export default {
	name: "ShareWithPeople",
	mixins: [successToast, errorToast],
	data() {
		return {
			excelFile: null,
			fileError: "",
			SheetName: "",
			downloadLink: "",
			openInd: true,
			openGrp: false,
			openRec: false,
			forceData: "",
			forceDataGroup: "",
			showThisWhenFirstTime: "",
			showThisWhenFirstTimeCreate: "",
			ShowMessageBox: "",
			successToastMessage: "",
			grptype: "",
			tabIndex: 0,
			individualCandidate: "",
			individualCandidateEmailSearch: "",
			groupSearch: "",
			addIndividualEmail: "",
			editIndividualEmail: "",
			evalSearch: "",
			candidateTypeData: "ng",
			sortColumn: "taggedAt",
			evaluatorLength: 0,
			showLoader: false,
			count: 10,
			currentPage: 1,
			filtercount: 0,
			pageStart: 0,
			pageEnd: null,
			total: null,
			totalPages: null,
			goToPage: null,
			candidateType: null,
			evaluatorOption: null,
			evalfilter: null,
			activeDropdownIndex: null,
			force: false,
			checkGroup: false,
			hideAfterFiveSecons: true,
			updatelink: false,
			checkEval: false,
			selectall: false,
			sorting: false,
			sortOrder: false,
			confirmModal: false,
			editIndividual: false,
			individualmail: false,
			grpcontainer: false,
			creategroup: false,
			sectionmodal: false,
			emailSelectedEmpty: false,
			filtermodalshow: false,
			groupLengthError: false,
			mailids: false,
			putapi: false,
			sectioneval: false,
			evaluatorSelect: false,
			evaluatorCheck: true,
			evaluatorTagged: true,
			LoaderStatus: false,
			check: true,
			selectedGroupDelIndividual: [],
			groupDatas: {},
			storeGroup: {},
			evaluators: [],
			selectedGroupDel: [],
			groupOptions: [],
			individualemials: [],
			emailSelected: [], // Must be an array reference!
			groups: [],
			options: [],
			excelEmails: [],
			evaluatorOptions: [
				{
					item: true,
					name: "Tagged",
				},
				{
					item: false,
					name: "Not Tagged",
				},
			],
			candidateTypesData: [
				{
					item: "sg",

					name: "Select Group",
				},
				{
					item: "ng",

					name: "Create New Group",
				},
			],
			selevaluator: [],
			selectedGroup: {
				groupName: "",
				candidates: [],
				evaluator: [],
			},
			candidateTypes: [
				{
					item: "G",
					name: "Group",
				},
				{
					item: "I",
					name: "Individual",
				},
			],
			roledata: {
				getIndividual: "",
				addIndividual: "",
				editIndividual: "",
				deleteIndividual: "",
				getGroup: "",
				addGroup: "",
				editGroup: "",
				deleteGroup: "",
				getconfig: "",
				tagevaluator: "",
			},
			listPrice: null,
			discount: null,
			setPricing: false,
			gatewayPercent: 0,
			gatewayConfig: {},
		};
	},
	components: {
		Spinner,
	},
	created() {
		this.LoaderStatus = true;
		this.tabRedirect();
		if (this.$route.params.testName != undefined) {
			this.setRoleData("auto");
		} else {
			this.setRoleData("share");
		}
		this.getGatewayCharges();
	},
	watch: {
		candidateType(value) {
			let type = "";
			if (value === "I") {
				type = "Individual";
				this.openIndividual();
			} else if (value === "G") {
				type = "Group";
				this.openGroup();
			} else {
				type = "Recruitment Group";
				this.openRecruitement();
			}
			this.$store.commit("searchVUEX/saveSelectedIndGrp", type);
			this.candidateType = value;
			// this.setValues();
		},
		candidateTypeData() {
			this.resetvalues(this.candidateTypeData);
			this.selectedGroup.evaluator = [];
			this.addIndividualEmail = "";
			this.selectedGroup.groupName = "";
			this.selectedGroup.candidates = [];
		},
		searchTopicTest(newValue, oldValue) {
			if (newValue != oldValue) {
				this.getShareGroupData("1", this.candidateType);
			}
		},
		individualCandidateEmailSearch() {
			this.showLoader = true;
			setTimeout(() => {
				this.showLoader = false;
			}, 200);
		},
		// tabIndex(newValue, oldValue) {
		//   console.log('intabind')
		//   if (newValue !== oldValue) {
		//     var groupType;
		//     switch (newValue) {
		//       case 0:
		//         groupType = "I";
		//         break;
		//       case 1:
		//         groupType = "G";
		//         break;
		//       case 2:
		//         groupType = "R";
		//         break;
		//       default:
		//         groupType = "I";
		//         break;
		//     }

		//     if (
		//       this.$route.name == "ConfigureTest" ||
		//       this.$route.query.testqp === "outside"
		//     ) {
		//       this.$router.push({
		//         path: `/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
		//         query: {
		//           groupType: groupType,
		//           autoqp: this.$route.query.autoqp,
		//           testqp: this.$route.query.testqp
		//         }
		//       });
		//     } else if (
		//       this.$route.name == "ConfigureAutogenerate" ||
		//       this.$route.query.autoqp === "outside"
		//     ) {
		//       this.$router.push({
		//         name: "ShareWithPeopleAutogenerate",
		//         params: {
		//           testID: this.$route.params.testID,
		//           topicID: this.$route.params.topicID,
		//           testName: this.$route.params.testName
		//         },
		//         query: {
		//           groupType: groupType,
		//           autoqp: this.$route.query.autoqp,
		//           testqp: this.$route.query.testqp
		//         }
		//       });
		//     } else if (
		//       this.$route.name == "ConfigureAutoQPBuilder" ||
		//       this.$route.query.autoqp === "inside"
		//     ) {
		//       this.$router.push({
		//         name: "ShareWithPeopleAutoQPBuilder",
		//         params: {
		//           testID: this.$route.params.testID,
		//           topicID: this.$route.params.topicID,
		//           testName: this.$route.params.testName
		//         },
		//         query: {
		//           groupType: groupType,
		//           autoqp: this.$route.query.autoqp,
		//           testqp: this.$route.query.testqp
		//         }
		//       });
		//     } else {
		//       this.$router.push({
		//         path: `/share/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
		//         query: {
		//           groupType: groupType,
		//           autoqp: this.$route.query.autoqp,
		//           testqp: this.$route.query.testqp
		//         }
		//       });
		//     }
		//   }
		// }
	},
	validations: {
		addIndividualEmail: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
		editIndividualEmail: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},
		selevaluator: {
			required: requiredIf(function() {
				return !this.evaluatorTagged;
			}),
		},
		selectedGroup: {
			groupName: {
				required,
				maxLength: maxLength(128),
			},
			evaluator: {
				required: requiredIf(function() {
					return !this.evaluatorTagged;
				}),
			},
		},
		individualCandidate: {
			required,
			email,
			alpha: helpers.regex("alpha", /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/),
		},

		listPrice: {
			required: requiredIf(function() {
				return this.setPricing;
			}),
			maxFiveDecimals,
			between: between(0, 100000),
		},

		discount: {
			minValue: minValue(0),
			maxFiveDecimals,
			notGreaterThanList: helpers.withParams(
				{ type: "notGreaterThanList" },
				function(value) {
					// IMPORTANT: skip validation if empty
					if (!helpers.req(value)) return true;

					return Number(value) < Number(this.listPrice);
				}
			),
		},
	},
	computed: {
		priceAfterDiscount() {
			if (!this.listPrice) return 0;
			return this.listPrice - (this.discount || 0);
		},

		gatewayAmount() {
			return (this.priceAfterDiscount * this.gatewayPercent) / 100;
		},

		finalReceivable() {
			return this.priceAfterDiscount - this.gatewayAmount;
		},
		deleteAccess() {
			//check if the user have access to delete data
			if (this.candidateType == "G" || this.candidateType == "R") {
				return this.roles.includes(this.roledata.deleteGroup);
			} else if (this.candidateType == "I") {
				return this.roles.includes(this.roledata.deleteIndividual);
			} else if (
				this.roles.includes(this.roledata.deleteIndividual) ||
				this.roles.includes(this.roledata.deleteGroup)
			) {
				return true;
			}
			return false;
		},
		optionssearch() {
			return this.options.filter((data) => {
				return (
					!this.addIndividualEmail ||
					data.groupName
						.toLowerCase()
						.includes(this.addIndividualEmail.toLowerCase())
				);
			});
		},
		optionssearchedit() {
			return this.options.filter((data) => {
				return (
					!this.editIndividualEmail ||
					data.groupName
						.toLowerCase()
						.includes(this.editIndividualEmail.toLowerCase())
				);
			});
		},
		individualemailsearch() {
			return this.individualemials.filter((data) => {
				return (
					!this.individualCandidate ||
					data.groupName
						.toLowerCase()
						.includes(this.individualCandidate.toLowerCase())
				);
			});
		},
		individualemailsearchList() {
			return this.individualemials.filter((data) => {
				return (
					!this.individualCandidateEmailSearch ||
					data.groupName
						.toLowerCase()
						.includes(this.individualCandidateEmailSearch.toLowerCase())
				);
			});
		},
		groupOptionSearch() {
			return this.groupOptions.filter((data) => {
				return (
					!this.groupSearch ||
					data.groupName.toLowerCase().includes(this.groupSearch.toLowerCase())
				);
			});
		},
		evalOptionSearch() {
			return this.evaluators.filter((data) => {
				return (
					!this.evalSearch ||
					data.name.toLowerCase().includes(this.evalSearch.toLowerCase())
				);
			});
		},
		emailSearch() {
			return this.evaluators.filter((data) => {
				return (
					!this.evalSearch ||
					data.name.toLowerCase().includes(this.evalSearch.toLowerCase())
				);
			});
		},
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
		...mapGetters("testVUEX", {
			selectedTest: "getSelectedTest",
		}),
		...mapGetters(["roles"]),
		// To check if it does not contain an alphabet or zero
		isValidPage() {
			return /^\d*$/.test(this.goToPage) && this.goToPage != 0;
		},
	},
	mounted() {
		window.addEventListener("keyup", this.handleKeyPress);
	},
	beforeDestroy() {
		window.removeEventListener("keyup", this.handleKeyPress);
	},
	methods: {
		hideshowPricingDetails() {
			if (this.setPricing) {
				this.discount = 0;
			} else {
				this.listPrice = null;
				this.discount = null;
			}
		},
		getDeviceMode() {
			const ua = navigator.userAgent || navigator.vendor || window.opera;

			if (/android/i.test(ua)) return "ANDROID";

			if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "IOS";

			if (/Mobi|Mobile/.test(ua)) return "MOBILE_WEB";

			return "WEB";
		},

		async getGatewayCharges() {
			try {
				const res = await getGatewayCharges();

				if (res.status == 200) {
					this.gatewayConfig = res.data.data.HIRE3X_FEE;

					const deviceMode = this.getDeviceMode();

					const feeObj = Object.values(this.gatewayConfig).find(
						(f) => f.mode === deviceMode
					);

					this.gatewayPercent = feeObj?.charge || 0;
				}
			} catch (error) {
				console.error(error);
			}
		},
		checkEvaluatorValidation() {
			this.evaluatorTagged = this.selectedGroup.evaluator.length > 0;
		},
		removeExcelFromPopUp() {
			this.excelFile = null;
		},
		handleUpload() {
			this.$refs["excel-upload-input"].click();
		},
		handleClick: function(event) {
			this.fileError = ""; // reset error first
			this.excelFile = event.target.files ? event.target.files[0] : null;

			if (!this.excelFile) return;

			const allowedTypes = [
				"application/vnd.ms-excel",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			];

			if (!allowedTypes.includes(this.excelFile.type)) {
				this.fileError = "Please upload a valid Excel file (.xls or .xlsx)";
				this.excelFile = null;
				this.$refs["excel-upload-input"].value = "";
				return;
			}

			// ✅ Clear error again just to be safe
			this.fileError = "";

			// Existing Excel logic
			const reader = new FileReader();
			reader.onload = (e) => {
				const arrayBuffer = e.target.result;
				const data = new Uint8Array(arrayBuffer);
				const wb = XLSX.read(data, { type: "array" });
				this.SheetName = wb.SheetNames[0];
			};
			reader.readAsArrayBuffer(this.excelFile);
		},
		removeExcelFile() {
			this.$refs["excel-upload-input"].value = null;
			this.excelFile = null;
		},
		acceptExcel() {
			let formData = new FormData();
			formData.append("file", this.excelFile);
			postGroupExcel(formData).then((res) => {
				if (res.status == 200) {
					this.excelEmails = res.data.data.emails;
					this.selectedGroup.candidates.push(...this.excelEmails);
					this.successToast("Excel sheets uploaded successfully");
				} else if (res.status === 400 || res.status === 404) {
					this.$nextTick(() => {
						this.errorToast(res.data.detail);
					});
				} else {
					this.errorToast("Something went wrong");
				}
				this.$bvModal.hide("excel-modal");
			});
		},
		getExcelTemplate() {
			getGroupTemplate()
				.then((res) => {
					this.downloadLink = res.data.data.downloadLink;
					this.download(this.downloadLink);
				})
				.catch((err) => {
					throw err;
				});
		},
		download(url) {
			const link = document.createElement("a");
			link.href = url;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		allowNumbers(event) {
			if (!/^\d$/.test(event.key)) {
				event.preventDefault();
			}
		},
		setValues() {
			if (
				this.$route.name == "configuresandbox" ||
				this.$route.query.testqp === "outside"
			) {
				this.$router.push({
					name: "sharesandbox",
					params: {
						topicID: this.$route.params.topicID,
						testID: this.$route.params.testID,
					},
					query: {
						groupType: this.candidateType,
						autoqp: this.$route.query.autoqp,
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else if (
				this.$route.name == "ConfigureTest" ||
				this.$route.query.testqp === "outside"
			) {
				console.log("1");
				this.$router.push({
					path: `/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
					query: {
						groupType: this.candidateType,
						autoqp: this.$route.query.autoqp,
						testqp: this.$route.query.testqp,
					},
				});
			} else if (
				this.$route.name == "ConfigureAutogenerate" ||
				this.$route.query.autoqp === "outside"
			) {
				console.log("2");
				this.$router.push({
					name: "ShareWithPeopleAutogenerate",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
					},
					query: {
						groupType: this.candidateType,
						autoqp: this.$route.query.autoqp,
						testqp: this.$route.query.testqp,
					},
				});
			} else if (
				this.$route.name == "ConfigureAutoQPBuilder" ||
				this.$route.query.autoqp === "inside"
			) {
				console.log("3");
				this.$router.push({
					name: "ShareWithPeopleAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						testName: this.$route.params.testName,
					},
					query: {
						groupType: this.candidateType,
						autoqp: this.$route.query.autoqp,
						testqp: this.$route.query.testqp,
					},
				});
			} else {
				console.log("4");
				this.$router.push({
					path: `/share/sharewithpeople/${this.$route.params.topicID}/${this.$route.params.testID}`,
					query: {
						groupType: this.candidateType,
						autoqp: this.$route.query.autoqp,
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
		openIndividual() {
			this.openInd = true;
			this.openGrp = false;
			this.openRec = false;
			this.selectall = false;
			this.selectedGroupDel = [];
			this.getShareGroupData("1", "I");
			this.candidateType = "I";
			this.cancelThis();
		},
		openGroup() {
			this.openInd = false;
			this.openGrp = true;
			this.openRec = false;
			this.selectall = false;
			this.selectedGroupDel = [];
			this.getShareGroupData("1", "G");
			this.candidateType = "G";
			this.cancelThis();
		},
		openRecruitement() {
			this.openInd = false;
			this.openGrp = false;
			this.openRec = true;
			this.selectall = false;
			this.selectedGroupDel = [];
			this.getShareGroupData("1", "R");
			this.candidateType = "R";
			this.cancelThis();
		},
		tabRedirect() {
			if (this.$route.query.groupType) {
				switch (this.$route.query.groupType) {
					case "I":
						this.openInd = true;
						this.openIndividual();
						break;
					case "G":
						this.openGrp = true;
						this.openGroup();
						break;
					case "R":
						this.openRec = true;
						this.openRecruitement();
						break;
				}
			}
			// else {
			//   this.getShareGroupData("1", "I");
			//   this.candidateType = "I";
			// }
		},
		setRoleData(type) {
			if (type == "auto") {
				this.roledata.getIndividual = "GET_AUTO_INDIVIDUAL";
				this.roledata.addIndividual = "PUSH_AUTO_INDIVIDUAL";
				this.roledata.editIndividual = "PUT_AUTO_INDIVIDUAL";
				this.roledata.deleteIndividual = "DELETE_AUTO_INDIVIDUAL";
				this.roledata.getGroup = "GET_AUTO_GROUP";
				this.roledata.addGroup = "PUSH_AUTO_GROUP";
				this.roledata.editGroup = "PUT_AUTO_GROUP";
				this.roledata.deleteGroup = "DELETE_AUTO_GROUP";
				this.roledata.getconfig = "GET_AUTO_TEST_CONFIG";
				this.roledata.tagevaluator = "TAG_AUTO_EVALUATOR";
			} else {
				this.roledata.getIndividual = "GET_TEST_INDIVIDUAL";
				this.roledata.addIndividual = "PUSH_TEST_INDIVIDUAL";
				this.roledata.editIndividual = "PUT_TEST_INDIVIDUAL";
				this.roledata.deleteIndividual = "DELETE_TEST_INDIVIDUAL";
				this.roledata.getGroup = "GET_TEST_GROUP";
				this.roledata.addGroup = "PUSH_TEST_GROUP";
				this.roledata.editGroup = "PUT_TEST_GROUP";
				this.roledata.deleteGroup = "DELETE_TEST_GROUP";
				this.roledata.getconfig = "GET_TEST_CONFIG";
				this.roledata.tagevaluator = "TAG_EVALUATOR";
			}
			if (!this.$route.query.groupType) {
				if (
					!this.roles.includes(this.roledata.getIndividual) &&
					this.roles.includes(this.roledata.getGroup)
				) {
					this.candidateType = "G";
				} else {
					this.candidateType = "I";
				}
			} else {
				this.candidateType = this.$route.query.groupType;
			}
		},
		handleKeyPress(event) {
			if (event.keyCode === 27) {
				this.cancelThis();
			}
		},

		toggleDropdown() {
			this.individualmail = !this.individualmail;
			this.individualCandidateEmailSearch = "";
			this.sectioneval = false;
			if (this.individualmail) {
				document.addEventListener("click", this.closeDropdown);
			} else {
				document.removeEventListener("click", this.closeDropdown);
			}
		},
		closeDropdown(event) {
			if (!this.$refs.dropdown.contains(event.target)) {
				this.individualmail = false;
				this.individualCandidateEmailSearch = "";
				document.removeEventListener("click", this.closeDropdown);
			}
		},
		toggleDropdownmailids() {
			this.mailids = !this.mailids;
			this.sectioneval = false;
			if (this.mailids) {
				document.addEventListener("click", this.closeDropdownmailids);
			} else {
				document.removeEventListener("click", this.closeDropdownmailids);
			}
		},
		closeDropdownmailids(event) {
			if (!this.$refs.dropdownmailids.contains(event.target)) {
				this.mailids = false;
				document.removeEventListener("click", this.closeDropdownmailids);
			}
		},
		toggleDropdownselectedGroup() {
			this.sectionmodal = !this.sectionmodal;
			this.groupSearch = "";
			this.mailids = false;
			this.sectioneval = false;
			if (this.sectionmodal) {
				document.addEventListener("click", this.closeDropdownselectedGroup);
			} else {
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},
		closeDropdownselectedGroup(event) {
			if (!this.$refs.expdropdownselectedGroup.contains(event.target)) {
				this.sectionmodal = false;
				document.removeEventListener("click", this.closeDropdownselectedGroup);
			}
		},
		hideexpertiseoptionsIndividual() {
			this.evaluatorSelect = false;
		},
		hideexpertiseoptionsIndividualEmailEDIT() {
			this.evaluatorSelect = false;
		},
		hideDropdownsemaildata() {
			this.activeDropdownIndex = null;
		},
		hideexpertiseoptionsEditIndividual() {
			this.evaluatorSelect = false;
		},
		hideexpertiseoptionsEditGroup() {
			this.evaluatorSelect = false;
		},
		hideexpertiseoptionsEval() {
			this.sectioneval = !this.sectioneval;
			this.evalSearch = "";
			this.mailids = false;
			this.sectionmodal = false;
			if (this.sectioneval) {
				document.addEventListener("click", this.closeDropdownselectedGroupEval);
			} else {
				document.removeEventListener(
					"click",
					this.closeDropdownselectedGroupEval
				);
			}
		},
		closeDropdownselectedGroupEval(event) {
			if (!this.$refs.hideexpertiseoptionsEvalref.contains(event.target)) {
				this.sectioneval = false;
				document.removeEventListener(
					"click",
					this.closeDropdownselectedGroupEval
				);
			}
		},
		showData(index) {
			if (this.activeDropdownIndex === index) {
				this.activeDropdownIndex = null;
			} else {
				this.activeDropdownIndex = index;
			}
		},
		shouldShowDropdown(index) {
			return this.activeDropdownIndex === index;
		},
		goTobackpage() {
			if (this.$route.name == "ShareWithPeopleAutogenerate") {
				this.$router.push({
					path: "/autogenerate",
					query: {
						type: this.$route.query.type,
						sort: this.$route.query.sort,
						status: this.$route.query.status,
					},
				});
			} else if (this.$route.name == "ShareWithPeopleTest") {
				this.$router.push({
					// path:"/"
					name: "Tests",
					params: {
						topicID: this.$route.params.topicID,
						topicName: this.selectedTopic.topicName,
					},
					query: {
						type: this.$route.query.type,
						sort: this.$route.query.sort,
						ttype: this.$route.query.ttype,
						tsort: this.$route.query.tsort,
						status: this.$route.query.status,
					},
				});
			} else if (this.$route.name == "ShareWithPeopleAutoQPBuilder") {
				this.$router.push({
					name: "AutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						testName: this.$route.params.testName,
					},
					query: {
						type: this.$route.query.type,
						sort: this.$route.query.sort,
						status: this.$route.query.status,
					},
				});
			} else if (this.$route.name == "sharesandbox") {
				this.$router.push({
					name: "myprojects",
				});
			} else {
				this.$router.push({
					name: `QPBuilder`,
					params: {
						testName: this.selectedTest.testName,
						testID: this.$route.params.testID,
						topicName: this.selectedTopic.topicName,
						topicID: this.$route.params.topicID,
					},
					query: {
						type: this.$route.query.type,
						sort: this.$route.query.sort,
						ttype: this.$route.query.ttype,
						tsort: this.$route.query.tsort,
						status: this.$route.query.status,
					},
				});
			}
		},
		async setPrevLinkStatus(group) {
			this.LoaderStatus = true;
			let payload = {
				prevLinkStatus: group.prevLinkStatus,
				groupID: group.groupID,
				testID: group.testID,
			};
			await setPrevLink(payload);
			this.LoaderStatus = false;
		},
		convertToLowerCase() {
			this.individualCandidate = this.individualCandidate.toLowerCase();
		},
		convertAaddIndividual() {
			this.addIndividualEmail = this.addIndividualEmail.toLowerCase();
		},
		converEditIndividualEmail() {
			this.editIndividualEmail = this.editIndividualEmail.toLowerCase();
		},
		// The pagination buttons functionality allow you to move backward and forward through the page
		goToPages(index) {
			this.currentPage = Math.max(1, Math.min(index, this.totalPages)) || 1;
			this.goToPage = null;
			this.getShareGroupData("1", this.candidateType);
		},
		goToPageNum() {
			this.getShareGroupData("1", this.candidateType);
		},
		evalUpdate() {
			this.checkEval = false;
			this.$forceUpdate();
		},
		killTagEvaluator() {
			this.evaluatorSelect = false;
			this.$bvModal.hide("modal-center");
		},
		resetvalues(data) {
			this.$v.$reset();
			this.sectionmodal = false;
			this.creategroup = false;
			this.sectioneval = false;
			if (data == "ng" || data == "sg") {
				this.grpcontainer = true;
			} else {
				this.grpcontainer = false;
			}
			this.emailSelectedEmpty = false;
			this.groupLengthError = false;
			this.individualCandidate = "";
			this.mailids = false;
			this.individualmail = false;
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
			this.selevaluator = [];
			this.checkEval = false;
			this.checkGroup = false;
			this.listPrice = null;
			this.finalPrice = null;
			this.discount = null;
			this.setPricing = false;
		},
		customHandler() {
			if (!this.$v.addIndividualEmail.$invalid) {
				this.groupLengthError = false;
				this.emailSelectedEmpty = false;
				this.selectedGroup.candidates.push(this.$v.addIndividualEmail.$model);
				this.addIndividualEmail = "";
				this.$forceUpdate();
				this.$v.$reset();
			}
		},
		customHandlerEdit() {
			if (!this.$v.editIndividualEmail.$invalid) {
				this.groupLengthError = false;
				this.emailSelectedEmpty = false;
				this.selectedGroup.candidates.push(this.$v.editIndividualEmail.$model);
				this.editIndividualEmail = "";
				this.$forceUpdate();
				this.$v.$reset();
			}
		},
		changeEmptyEmail() {
			this.addIndividualEmail = "";
			this.editIndividualEmail = "";
			this.updateCandidateDets();
			if (this.selectedGroup.candidates.length > 0) {
				this.emailSelectedEmpty = false;
			}
			if (this.selectedGroup.candidates.length >= 2) {
				this.groupLengthError = false;
			}
		},
		updateCandidateDets() {
			if (!this.selectedGroup.candidateDets) {
				this.$set(this.selectedGroup, "candidateDets", []);
			}

			const existingEmailIDs = this.selectedGroup.candidateDets.map(
				(obj) => obj.emailID
			);

			const newEmailIDs = this.selectedGroup.candidates.filter(
				(email) => !existingEmailIDs.includes(email)
			);

			newEmailIDs.forEach((emailID) => {
				this.selectedGroup.candidateDets.push({
					currentLink: null,
					emailID,
					prevLink: [],
					shareStatus: false,
				});
			});
		},
		customAdd() {
			if (!this.$v.addIndividualEmail.$error) {
				this.selectedGroup.candidates.push(this.$v.addIndividualEmail.$model);
				this.addIndividualEmail = "";
				this.$v.$reset();
				this.emailSelectedEmpty = false;
				if (this.selectedGroup.candidates.length >= 2) {
					this.groupLengthError = false;
				}
			}
		},
		customEdit(ip) {
			this.$v.editIndividualEmail.$touch();
			if (!this.$v.editIndividualEmail.$error) {
				this.selectedGroup.candidates.push(ip.value);
				this.editIndividualEmail = "";
				this.$v.$reset();
				this.emailSelectedEmpty = false;
				if (this.selectedGroup.candidates.length >= 2) {
					this.groupLengthError = false;
				}
			}
		},
		sort(data) {
			this.sortColumn = data;
			this.sortOrder = !this.sortOrder;
			this.getShareGroupData("1", this.candidateType);
		},
		filter() {
			this.evalfilter = this.evaluatorOption;
			this.currentPage = 1;
			this.filtercount = 0;
			if (this.evaluatorOption != null) {
				this.filtercount++;
			}
			this.filtermodalshow = false;
			this.getShareGroupData("1", this.candidateType);
		},
		modalpop() {
			this.evaluatorOption = this.evalfilter;
			this.filtermodalshow = !this.filtermodalshow;
		},
		hideDropdown() {
			this.filtermodalshow = false;
		},
		clearfilter() {
			if (this.filtercount != 0) {
				this.filtermodalshow = false;
				this.evaluatorOption = null;
				this.getShareGroupData("1", this.candidateType);
			}
			this.currentPage = 1;
			this.filtercount = 0;
			this.evaluatorOption = null;
			this.evalfilter = null;
		},
		closefilter() {
			this.filtermodalshow = false;
			if (this.filtercount == 0) {
				this.evaluatorOption = null;
			}
		},
		linkconfirmmodal(data) {
			this.storeGroup = data;
			this.$bvModal.show("modal-confirm");
		},
		linkGenerate() {
			if (this.storeGroup.shareLink == null) {
				this.generatelink(this.storeGroup.groupID);
			} else {
				this.updatelink = true;
				this.generatelink(this.storeGroup.groupID);
			}
			this.$bvModal.hide("modal-confirm");
			this.storeGroup = {};
		},
		linkShareModal(data) {
			this.storeGroup = data;
			this.$bvModal.show("modal-shareLink");
		},
		linkShare() {
			this.shareLink(this.storeGroup.groupID);
			this.$bvModal.hide("modal-shareLink");
			this.storeGroup = {};
		},
		async saveIndividual() {
			try {
				this.$v.individualCandidate.$touch();
				this.$v.selevaluator.$touch();
				this.$v.listPrice.$touch();
				this.$v.discount.$touch();
				if (Number(this.discount) < 0) {
					this.errorToast("Please don’t enter a negative number");
					return;
				}
				if (
					(this.$v.discount.$dirty && !this.$v.discount.maxFiveDecimals) ||
					(this.$v.listPrice.$dirty && !this.$v.listPrice.maxFiveDecimals)
				) {
					this.errorToast(
						"Please enter a valid price with up to 5 decimal places"
					);
					return;
				}
				// STEP 2: MANUAL > listPrice check
				if (this.discount && Number(this.discount) > Number(this.listPrice)) {
					this.errorToast(
						"Discount cannot be greater or equal than list price"
					);
					return;
				}
				this.checkEval =
					!this.evaluatorTagged && this.selevaluator.length === 0;

				if (this.$v.individualCandidate.$invalid || this.checkEval) {
					this.errorToast("Please enter all the details");
					return;
				}

				if (
					this.$v.individualCandidate.$invalid ||
					this.$v.selevaluator.$invalid ||
					this.$v.listPrice.$invalid ||
					this.$v.discount.$invalid
				) {
					return;
				}
				this.LoaderStatus = true;
				const candidates = [this.individualCandidate];
				const groupType = "I";

				const payload = {
					portion: "Group",
					name: this.putapi ? undefined : this.individualCandidate,
					groupName: this.putapi ? undefined : this.individualCandidate,
					groupID: this.putapi ? this.selectedGroup.groupID : undefined,
					testID: this.$route.params.testID,
					topicID: this.$route.params.topicID,
					evaluator: this.selevaluator,
					setPricing: this.setPricing,

					groupType,
					candidates,
				};
				if (this.setPricing) {
					payload.pricingDetails = {
						pricingType: 2,
						discountAmount: this.discount,
						listPrice: Number(this.listPrice),
					};
				}
				if (this.force) {
					payload.force = true;
				}

				const apiFunction = this.putapi ? putShareGroup : postShareGroup;
				const res = await apiFunction(payload);

				if (res.status === 200) {
					this.LoaderStatus = false;
					this.handleSuccess();
				} else if (res.status === 208) {
					this.handleForce(res.data.data.details);
				} else if (res.status === 409 || res.status === 208) {
					this.errorToast(res.data.data.Data);
				}

				this.handleForceCleanup();
			} catch (error) {
				this.handleApiError(error);
			}
		},
		handleSuccess() {
			this.getShareGroupData("1", this.candidateType);
			this.resetvalues();
			this.showThisWhenFirstTimeCreate = "ok";
			this.successToastMessage = "Individual email added successfully";
			this.ShowMessageBox = "showToast";
		},

		handleForce(forceData) {
			this.forceDataGroup = forceData;
			this.$bvModal.show("confirm-modal-group-addForce");
			this.grpcontainer = false;
		},

		handleForceCleanup() {
			if (this.force) {
				this.force = false;
				this.forceData = "";
				this.$bvModal.hide("confirm-modal-group-addForce");
			}
		},

		handleApiError(error) {
			this.errorToast(
				error.response?.data?.data?.Data || "Failed! Status: Unknown"
			);
			throw new Error(`Failed! Status: ${error.status}`);
		},
		goToConfigure(group) {
			if (this.$route.name == "ShareWithPeopleTest") {
				this.$router.push({
					name: "Configure",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: group.groupID,
						groupType: group.candidateType,
					},
					query: {
						testqp: this.$route.query.testqp,
					},
				});
			} else if (this.$route.name == "ShareWithPeopleAutogenerate") {
				this.$router.push({
					name: "ConfigureAutogenerate",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: group.groupID,
						testName: this.$route.params.testName,
						groupType: group.candidateType,
					},
					query: {
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "ShareWithPeopleAutoQPBuilder") {
				this.$router.push({
					name: "ConfigureAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: group.groupID,
						testName: this.$route.params.testName,
						groupType: group.candidateType,
					},
					query: {
						autoqp: this.$route.query.autoqp,
					},
				});
			} else if (this.$route.name == "sharesandbox") {
				this.$router.push({
					name: "configuresandbox",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: group.groupID,
						groupType: group.candidateType,
					},
					query: {
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else {
				this.$router.push({
					path: `/share/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${group.groupID}/${group.candidateType}`,
					query: {
						testqp: this.$route.query.testqp,
					},
				});
			}
		},
		async copyToClipboard(id) {
			/* Get the text field */
			let copyLink = document.getElementById("shrelink" + id);

			try {
				/* Attempt to copy text to clipboard */
				await navigator.clipboard.writeText(copyLink.value);

				/* Update tooltip text */
				document.querySelector(".tooltip-inner").innerText = "Copied";
			} catch (err) {
				console.error("Unable to copy to clipboard", err);
			}
		},
		async addIndividual() {
			this.resetvalues();
			this.getEvaluators();
			this.grptype = "individual";
			this.grpcontainer = true;
			let data = {
				tag: 0,
				testID: this.$route.params.testID,
				groupType: "I",
			};
			const res = await taggedGroup(data);
			if (res.status == 200) {
				this.individualemials = res.data.data;
			}
		},
		addevaluator() {
			this.resetvalues();
			this.getEvaluators();
			this.evalSearch = "";
		},
		indCandChange(data) {
			if (!this.individualCandidate) {
				this.individualCandidate = "";
				this.putapi = false;
			} else if (
				this.individualCandidate != "" ||
				this.individualCandidate != null
			) {
				this.putapi = true;
				this.selectedGroup = data;
			} else {
				this.putapi = false;
				this.individualCandidate = "";
			}
		},
		async opengrpcontainer() {
			this.getEvaluators();
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
			this.resetvalues();
			this.grpcontainer = true;
			this.candidateTypeData = "ng";
			this.selectedGroup = {
				groupName: "",
				candidates: [],
				evaluator: [],
			};
			this.selevaluator = [];
			this.grptype = "create";
			let data = {
				tag: 0,
				testID: this.$route.params.testID,
				groupType: "G",
			};
			const res = await taggedGroup(data);
			if (res.status == 200) {
				this.groupOptions = res.data.data;
			}
			let data1 = {
				tag: 0,
				testID: this.$route.params.testID,
				groupType: "I",
			};
			const res2 = await taggedGroup(data1);
			if (res2.status == 200) {
				this.options = res2.data.data;
			}
		},
		async getEvaluators() {
			const res = await getEvalList();
			if (res.status == 200) {
				this.evaluators = res.data.data;
			}
		},
		createGroupOpen() {
			this.selectedGroup = {
				groupName: "",
				candidates: [],
				evaluator: [],
			};
			this.checkEval = false;
			this.creategroup = true;
			this.sectionmodal = false;
			this.editIndividualEmail = "";
			this.addIndividualEmail = "";
		},
		selectGroup() {
			this.selectedGroup = {
				groupName: "",
				candidates: [],
				evaluator: [],
			};
			this.creategroup = false;
		},
		async editPerticularGroup(group) {
			this.selectedGroupDel = [];
			if (this.selectedGroupDel.length != this.groups.length) {
				this.selectall = false;
			}
			this.evaluatorLength = group.evaluator.length;
			this.groupDatas = group;
			group.view = false;
			this.resetvalues();
			this.getEvaluators();
			this.grpcontainer = true;
			if (group.candidateType == "G" || group.candidateType == "R") {
				this.selectedGroup = JSON.parse(JSON.stringify(group));
				this.listPrice = group.listPrice || null;
				this.finalPrice = group.finalPrice || null;
				this.discount = group.discountAmount;
				this.setPricing = group.listPrice != null && group.finalPrice != null;

				this.editIndividual = false;
				let data1 = {
					tag: 0,
					testID: this.$route.params.testID,
					groupType: "I",
				};

				const res2 = await taggedGroup(data1);
				if (res2.status == 200) {
					this.options = res2.data.data;
				}
			} else {
				this.selectedGroup = JSON.parse(JSON.stringify(group));
				this.listPrice = group.listPrice || null;
				this.finalPrice = group.finalPrice || null;
				this.discount = group.discountAmount;
				this.setPricing = group.listPrice != null && group.finalPrice != null;

				this.individualCandidate = group.groupName;
				this.selevaluator = group.evaluator;
				this.editIndividual = true;
			}
			this.grptype = "edit";
			this.$v.$reset();
		},
		viewParticularGroup(group) {
			this.selectedGroupDel = [];
			if (this.selectedGroupDel.length != this.groups.length) {
				this.selectall = false;
			}
			this.selectedGroupDel = [];
			this.evaluatorLength = group.evaluator.length;
			this.groupDatas = group;
			this.groups.forEach((object) => {
				object.view = false;
			});
			group.view = true;
			this.resetvalues();
			this.grpcontainer = true;
			this.selectedGroup = group;
			this.grptype = "view";
		},
		unView(group) {
			group.view = false;
			this.$forceUpdate();
			this.grpcontainer = false;
		},
		cancelThis() {
			this.groups.forEach((object) => {
				object.view = false;
			});
			this.$forceUpdate();
			this.selectedGroup = {
				groupName: "",
				candidates: [],
				evaluator: [],
			};
			this.resetvalues();
			this.grpcontainer = false;
			this.checkGroup = false;
			this.grptype = "";
			this.evaluatorSelect = false;
			this.evaluatorTagged = this.evaluatorCheck;
		},
		cancelEdit() {
			this.selectedGroup = {
				groupName: "",
				candidates: [],
			};
			this.resetvalues();
			this.grpcontainer = false;
		},
		async updateIndividual() {
			this.$v.individualCandidate.$touch();
			this.$v.selevaluator.$touch();
			this.$v.listPrice.$touch();
			this.$v.discount.$touch();
			if (this.discount && Number(this.discount) > Number(this.listPrice)) {
				this.errorToast("Discount cannot be greater or equal than list price");
				return;
			}

			if (
				(this.$v.discount.$dirty && !this.$v.discount.maxFiveDecimals) ||
				(this.$v.listPrice.$dirty && !this.$v.listPrice.maxFiveDecimals)
			) {
				this.errorToast(
					"Please enter a valid price with up to 5 decimal places"
				);
				return;
			}

			this.checkEval = !this.evaluatorTagged && this.selevaluator.length === 0;

			if (this.$v.individualCandidate.$invalid || this.checkEval) {
				this.errorToast("Please enter all the details");
				return;
			}
			try {
				if (
					!this.$v.individualCandidate.$invalid &&
					!this.$v.selevaluator.$invalid
				) {
					this.LoaderStatus = true;
					let candidates = [];
					candidates.push(this.individualCandidate);
					let payload = {
						portion: "Group",
						groupName: this.individualCandidate,
						groupID: this.selectedGroup.groupID,
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						evaluator: this.selectedGroup.evaluator,
						groupType: "I",
						candidates: candidates,
						setPricing: this.setPricing,
					};
					if (this.setPricing) {
						payload.pricingDetails = {
							pricingType: 2,
							discountAmount: this.discount,
							listPrice: Number(this.listPrice),
						};
					}
					const res = await putShareGroup(payload);
					if (res.status == 200) {
						this.LoaderStatus = false;
						this.successToast("Individual email updated successfully");
						this.getShareGroupData("1", this.candidateType);
						this.resetvalues();
					}
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		changeSelectedGroupCheck() {
			if (!this.selectedGroup) {
				this.selectedGroup = {
					groupName: "",
					candidates: [],
					evaluator: [],
				};
			} else {
				this.selectedGroup.evaluator = [];
			}
		},
		changeSelectedEmailCheck() {
			if (this.individualCandidate == "") {
				this.selectedGroup = {
					groupName: "",
					candidates: [],
					evaluator: [],
				};
				this.putapi = false;
			}
		},
		async getShareGroupData(data, data2) {
			try {
				this.LoaderStatus = true;
				const payload = this.buildPayload(data, data2);
				const res = await postTaggedGroup(payload);

				if (res.status === 200) {
					this.handleApiResponse(res.data.data);
					this.handleViewParticularGroup();
					this.handleToastMessages();
				}

				this.LoaderStatus = false;
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		buildPayload(data, data2) {
			const payload = {
				tag: data,
				page: this.currentPage - 1,
				count: this.count,
				sortBy: this.buildSortByObject(),
				filters: this.buildFiltersObject(data2),
				evaluator: this.buildEvaluatorOption(),
				configID: this.selectGroup?.configID || null,
				searchQuery: this.searchTopicTest || null,
				testID: this.$route.params.testID,
			};

			this.cleanupPayload(payload);
			return payload;
		},

		buildSortByObject() {
			return this.sortColumn
				? { column: this.sortColumn, order: this.sortOrder }
				: null;
		},

		buildFiltersObject(data2) {
			return data2 ? { candidateType: data2 } : null;
		},

		buildEvaluatorOption() {
			return this.evaluatorOption !== null ? this.evaluatorOption : null;
		},

		cleanupPayload(payload) {
			for (const key in payload) {
				if (payload[key] == null || payload[key] === "") {
					delete payload[key];
				}
			}
		},

		handleApiResponse(data) {
			if (Object.keys(data).length > 1 && data.data.length >= 0) {
				this.updateGroups(data);
				this.handleShowThisWhenFirstTime();
				this.updatePageDetails(data);
			} else {
				this.resetGroups();
			}

			this.evaluatorCheck = data.evaluatorCheck;
			this.evaluatorTagged = data.evaluatorCheck;
			this.checkConfiguredGroups();
		},

		updateGroups(data) {
			this.groups = data.data.map((object) => ({ ...object, view: false }));
		},

		handleShowThisWhenFirstTime() {
			if (this.showThisWhenFirstTimeCreate === "ok") {
				this.groups.forEach((object, i) => {
					object.showThisWhenFirstTime = i === 0;
				});
			} else {
				this.groups.forEach((object) => {
					object.showThisWhenFirstTime = false;
				});
			}

			this.showThisWhenFirstTimeCreate = "";
		},

		updatePageDetails(data) {
			this.pageEnd = data.pageEnd;
			this.pageStart = data.pageStart;
			this.total = data.total;
			this.totalPages = Math.ceil(parseInt(this.total) / parseInt(this.count));
		},

		resetGroups() {
			this.groups = [];
			this.pageEnd = 0;
			this.pageStart = 0;
			this.total = 0;
			this.evaluatorTagged = true;
			this.totalPages = 0;
		},

		checkConfiguredGroups() {
			this.groups.forEach((group) => {
				group.configured = !!group.config;
			});
			this.checkSelectAll();
		},

		handleViewParticularGroup() {
			if (this.grptype === "view") {
				const obj = this.groups.find(
					(group) => group.groupID === this.selectedGroup.groupID
				);
				this.viewParticularGroup(obj);
			}
		},
		handleToastMessages() {
			if (this.ShowMessageBox === "showToast") {
				this.successToast(this.successToastMessage);
				this.successToastMessage = "";
				this.ShowMessageBox = "";
			}
		},
		async getGroup(data, data2) {
			try {
				let payload = {
					tag: data,
					page: this.currentPage - 1,
					count: this.count,
					sortBy: {
						column: this.sortColumn,
						order: this.sortOrder,
					},
					filters: {
						candidateType: this.candidateType,
					},
					evaluator: this.evaluatorOption,
					configID: this.selectGroup["configID"],
					searchQuery: this.searchTopicTest,
					testID: this.$route.params.testID,
					groupID: data2,
				};
				if (payload.sortBy.column == null) {
					delete payload.sortBy;
				}
				if (payload.evaluator == null) {
					delete payload.evaluator;
				}
				if (payload.filters.candidateType == null) {
					delete payload.filters;
				}
				if (payload.searchQuery == "") {
					delete payload.searchQuery;
				}
				const res = await postTaggedGroup(payload);
				if (res.status == 200) {
					this.storegroups = res.data.data.data;
					this.editPerticularGroup(this.storegroups[0]);
				}
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async createGroup() {
			this.$v.addIndividualEmail.$reset();
			this.$v.selectedGroup.$touch();
			if (this.setPricing) {
				this.$v.listPrice.$touch();
				this.$v.discount.$touch();
				if (this.discount && Number(this.discount) > Number(this.listPrice)) {
					this.errorToast(
						"Discount cannot be greater or equal than list price"
					);
					return;
				}
			}

			try {
				this.validateCreateInputs();
				if (
					this.$v.selectedGroup.$invalid ||
					(this.setPricing && this.$v.listPrice.$invalid) ||
					(this.setPricing && this.$v.discount.$invalid) ||
					this.emailSelectedEmpty ||
					this.groupLengthError ||
					this.checkEval
				) {
					return;
				}
				this.LoaderStatus = true;
				await this.postShareGroup();
			} catch (error) {
				this.handleCreateError(error);
			} finally {
				this.LoaderStatus = false;
			}
		},

		validateCreateInputs() {
			this.checkEval =
				!this.evaluatorTagged && this.selectedGroup.evaluator.length === 0;

			this.emailSelectedEmpty = this.selectedGroup.candidates.length === 0;

			this.groupLengthError = this.selectedGroup.candidates.length < 2;
			if (
				!this.evaluatorTagged &&
				(this.$v.selectedGroup.$invalid ||
					this.$v.listPrice.$invalid ||
					this.$v.discount.$invalid ||
					this.emailSelectedEmpty ||
					this.checkEval)
			) {
				this.errorToast("Please fill all the details");
			} else if (
				this.evaluatorTagged &&
				(this.$v.selectedGroup.$invalid ||
					this.$v.listPrice.$invalid ||
					this.$v.discount.$invalid ||
					this.emailSelectedEmpty)
			) {
				this.errorToast("Please fill all the details");
			} else if (this.groupLengthError) {
				this.errorToast("Two or more candidates required");
			}
		},

		async postShareGroup() {
			const payload = {
				portion: "Group",
				name: this.selectedGroup.groupName,
				testID: this.$route.params.testID,
				topicID: this.$route.params.topicID,
				groupType: "G",
				candidates: this.selectedGroup.candidates,
				evaluator: this.selectedGroup.evaluator,
				setPricing: this.setPricing,
			};
			if (this.setPricing) {
				payload.pricingDetails = {
					pricingType: 2,
					discountAmount: this.discount,
					listPrice: Number(this.listPrice),
				};
			}
			const res = await postShareGroup(payload);

			if (res.status === 409) {
				this.errorToast(res.data.data.Data);
			} else if (res.status === 200) {
				this.LoaderStatus = false;
				this.handleSuccessfulGroupCreation();
			}

			return res;
		},

		handleSuccessfulGroupCreation() {
			this.grpcontainer = false;
			this.grptype = "";
			this.getShareGroupData("1", this.candidateType);
			this.successToastMessage = "Group created successfully";
			this.ShowMessageBox = "showToast";
			this.showThisWhenFirstTimeCreate = "ok";
		},

		handleCreateError(error) {
			this.errorToast(error.response?.data?.data?.Data || "An error occurred");
		},
		async updateGroup() {
			console.log("heyyy");
			this.$v.selectedGroup.$touch();
			// if (this.setPricing) {
			// 	this.$v.listPrice.$touch();
			// 	this.$v.finalPrice.$touch();
			// }
			if (this.selectedGroup.candidates.length == 0) {
				this.emailSelectedEmpty = true;
				this.groupLengthError = true;
			} else if (this.selectedGroup.candidates.length < 2) {
				this.groupLengthError = true;
				this.emailSelectedEmpty = false;
			} else {
				this.groupLengthError = false;
				this.emailSelectedEmpty = false;
			}
			try {
				if (
					!this.$v.selectedGroup.$invalid &&
					(!this.setPricing ||
						(!this.$v.listPrice.$invalid && !this.$v.discount.$invalid)) &&
					!this.groupLengthError
				) {
					this.LoaderStatus = true;
					let payload = {
						groupName: this.selectedGroup.groupName,
						evaluator: this.selectedGroup.evaluator,
						candidates: this.selectedGroup.candidates,
						groupID: this.selectedGroup.groupID,
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupType: this.selectedGroup.candidateType,
						check: this.check,
						setPricing: this.setPricing,
					};
					if (this.setPricing) {
						payload.pricingDetails = {
							pricingType: 2,
							discountAmount: this.discount,
							listPrice: Number(this.listPrice),
						};
					}
					console.log(payload, "payload");

					const res = await putShareGroup(payload);
					if (res.status == 200) {
						this.LoaderStatus = false;
						this.getShareGroupData("1", this.candidateType);
						this.successToastMessage = "Group updated successfully";
						this.ShowMessageBox = "showToast";
						this.grpcontainer = false;
						this.check = true;
					} else if (res.status == 409) {
						this.$bvModal.show("confirm-edit");
					}
				}
			} catch (error) {
				this.errorToast(error.response.data.data.Data);
			}
		},
		confirm() {
			this.check = false;
			this.updateGroup();
			this.$bvModal.hide("confirm-edit");
		},
		cancel() {
			this.check = true;
			this.$bvModal.hide("confirm-edit");
		},
		addTag() {
			this.mailids = false;
			this.$forceUpdate();
		},
		removeSelectedEmail(index) {
			this.selectedGroup.candidates.splice(index, 1);
			if (this.selectedGroup.candidates.length == 0) {
				this.emailSelectedEmpty = true;
			} else {
				this.emailSelectedEmpty = false;
			}
		},
		removeEmail(index) {
			this.selectedGroup.candidates.splice(index, 1);
			if (this.selectedGroup.candidates.length == 0) {
				this.emailSelectedEmpty = true;
			} else {
				this.emailSelectedEmpty = false;
			}
		},
		removeEvaluator(i) {
			this.selectedGroup.evaluator.splice(i, 1);
			this.$forceUpdate();
		},
		removeIndiEvaluator(i) {
			this.selevaluator.splice(i, 1);
		},
		async addSelectedGroup() {
			this.hideAfterFiveSeconds();

			this.checkGroup = this.selectedGroup.groupName === "";

			try {
				this.$v.selectedGroup.$touch();
				// this.$v.listPrice.$touch();
				// this.$v.finalReceivable.$touch();
				if (this.validateInputs()) {
					const payload = this.buildPayloadSelectedGroup();
					const res = await putShareGroup(payload);

					if (res.status === 200) {
						this.handleSuccessfulGroupAddition();
					} else if (res.status === 208) {
						this.handleForceDataGroup(res.data.data.details);
					} else {
						this.handleError(res.data.data.Data);
					}
					if (this.force) {
						this.force = false;
						this.forceData = "";
						this.$bvModal.hide("confirm-modal-group-addForce");
					}
				}
			} catch (error) {
				this.handleError("Something went wrong", error);
			}
		},

		hideAfterFiveSeconds() {
			this.hideAfterFiveSecons = true;
			setTimeout(() => {
				this.hideAfterFiveSecons = false;
			}, 5000);
		},

		validateInputs() {
			this.checkEval =
				!this.evaluatorTagged && this.selectedGroup.evaluator.length === 0;

			if (
				this.$v.selectedGroup.$invalid ||
				this.$v.listPrice.$invalid ||
				this.$v.discount.$invalid ||
				this.checkEval
			) {
				this.errorToast("Please fill all the details");
				return false;
			}

			return true;
		},

		buildPayloadSelectedGroup() {
			const payload = {
				testID: this.$route.params.testID,
				groupID: this.selectedGroup.groupID,
				evaluator: this.selectedGroup.evaluator,
				groupType: this.selectedGroup.candidateType,
				topicID: this.$route.params.topicID,
				setPricing: this.setPricing,
			};
			if (this.setPricing) {
				payload.pricingDetails = {
					pricingType: 2,
					discountAmount: this.discount,
					listPrice: Number(this.listPrice),
				};
			}
			if (this.force) {
				payload["force"] = true;
			}

			return payload;
		},
		handleSuccessfulGroupAddition() {
			this.getShareGroupData("1", this.candidateType);
			this.successToastMessage = "Group added successfully";
			this.ShowMessageBox = "showToast";
			this.grpcontainer = false;
			this.grptype = "";
			this.showThisWhenFirstTimeCreate = "ok";
		},

		handleForceDataGroup(details) {
			this.forceDataGroup = details;
			this.$bvModal.show("confirm-modal-group-addForce");
			this.grpcontainer = false;
		},

		handleError(errorMessage, error) {
			this.errorToast(errorMessage);
			throw new Error(`Failed! Status: ${error?.status}`);
		},

		async generatelink(data) {
			try {
				this.LoaderStatus = true;
				let payload = {
					testID: this.$route.params.testID,
					groupID: data,
				};
				const res = await generateLink(payload);
				if (res.status == 200) {
					await this.getShareGroupData("1", this.candidateType);
					if (this.updatelink) {
						this.successToast("Link updated successfully");
					} else {
						this.successToast("Link generated successfully");
					}
					let index = this.groups.findIndex((i) => i.groupID == data);
					this.selectedGroup = this.groups[index];
				} else {
					this.errorToast(res.data.data.details);
				}
				this.LoaderStatus = false;
			} catch (error) {
				console.log(error);
				this.LoaderStatus = false;
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async shareLink(data) {
			try {
				this.LoaderStatus = true;
				let payload = {
					testID: this.$route.params.testID,
					groupID: data,
				};
				const res = await shareLink(payload);
				if (res.status == 200) {
					this.getShareGroupData("1", this.candidateType);
					setTimeout(() => {
						this.successToast("Link shared successfully");
					}, 2000);
				}
				this.LoaderStatus = false;
			} catch (error) {
				this.errorToast("Something went wrong");
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async shareToIndividual(data) {
			try {
				let payload = {
					testID: this.$route.params.testID,
					groupID: this.selectedGroup.groupID,
					candidateList: [],
				};
				payload.candidateList.push(data);
				const res = await shareLink(payload);
				if (res.status == 200) {
					this.getShareGroupData("1", this.candidateType);

					this.successToast("Link shared successfully");
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		checkSelectAll() {
			let isSelectedAll = true;
			if (this.groups.length == 0) {
				isSelectedAll = false;
			} else {
				for (const record of this.groups) {
					if (
						this.selectedGroupDel.filter((value) => value === record.groupID)
							.length === 0
					) {
						isSelectedAll = false;
					}
				}
			}
			this.selectall = isSelectedAll;
		},
		selectAll() {
			if (this.selectall) {
				for (let i in this.groups) {
					if (
						this.selectedGroupDel.filter(
							(value) => value == this.groups[i].groupID
						).length === 0
					) {
						this.selectedGroupDel.push(this.groups[i].groupID);
					}
				}
			} else {
				for (let j in this.groups) {
					if (
						this.selectedGroupDel.filter(
							(value) => value == this.groups[j].groupID
						).length > 0
					) {
						this.selectedGroupDel.splice(
							this.selectedGroupDel.indexOf(this.groups[j].groupID),
							1
						);
					}
				}
			}
		},
		deselect() {
			this.selectall = false;
			const containsAll = this.groups.every((element) => {
				return this.selectedGroupDel.includes(element.groupID);
			});
			if (containsAll) {
				this.selectall = true;
			}
		},
		resetAddModal() {
			this.sectioneval = "";
		},
		async deleteGroup() {
			try {
				let payload = {
					testID: this.$route.params.testID,
					groupID: this.selectedGroupDel,
				};
				const res = await deleteShareGroup(payload);
				if (res.status == 200) {
					this.successToast(res.data.data.Details);
					this.getShareGroupData("1", this.candidateType);
					this.$bvModal.hide("modal-delete");
					this.selectedGroupDel = [];
					this.selectall = false;
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				this.$bvModal.hide("modal-delete");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		deleteGroupstepOne(groupID) {
			this.selectedGroupDelIndividual = [groupID];
			this.$bvModal.show("modal-delete-individual");
		},
		async deleteGroupIndividually() {
			try {
				let payload = {
					testID: this.$route.params.testID,
					groupID: this.selectedGroupDelIndividual,
				};
				const res = await deleteShareGroup(payload);
				if (res.status == 200) {
					this.successToast(" Selected data deleted successfully");
					this.getShareGroupData("1", this.candidateType);
					this.$bvModal.hide("modal-delete-individual");
					this.selectedGroupDelIndividual = [];
					this.selectall = false;
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				this.$bvModal.hide("modal-delete-individual");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async evaluatorTag() {
			try {
				let payload = {
					testID: this.$route.params.testID,
					groupIDs: this.selectedGroupDel,
					evaluator: this.selevaluator,
				};
				const res = await tagEvaluator(payload);
				if (res.status == 200) {
					this.successToast("Evaluator tagged successfully");
					this.getShareGroupData("1", this.candidateType);
					this.$bvModal.hide("modal-center");
					this.selectedGroupDel = [];
					this.selectall = false;
				}
			} catch (error) {
				this.errorToast("Something went wrong");
				this.$bvModal.hide("modal-center");
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
	},
};
</script>
<style>
::-webkit-scrollbar-thumb:hover {
	background-color: #72738e;
	border-radius: 5px;
	width: 30px;
	height: 100px;
}

.swp-check-email-individualmail > .custom-control-label::before {
	display: none;
}
.selected-row {
	background-color: rgb(232, 240, 254);
	border: 1px solid rgb(51, 121, 179);
}
.swp-reports-table .btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: none;
}

#swp-main-container {
	overflow: hidden;
}

.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(13px);
	background: white;
}

input:checked + .slider {
	background-color: #72738e;
}

.slider:before {
	position: absolute;
	content: "";
	height: 14px;
	width: 14px;
	left: 1px;
	bottom: 1px;
	background-color: #adb5bd;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border: 1px solid #72738e;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

.switch {
	position: relative;
	display: inline-block;
	width: 30px;
	height: 17px;
}

.sh-grp-sec-modal {
	position: absolute;
	width: 100%;
	top: 38px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	padding: 15px;
	z-index: 6;
}

.grp-sec-modal {
	position: absolute;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	border-radius: 5px;
	z-index: 6;
	top: 40px;
}

.swp-grp-sec-modal {
	position: absolute;
	background: #ffffff;
	border: 0.5px solid rgba(10, 86, 200, 0.5);
	border-radius: 5px;
	z-index: 6;
	top: 38px;
}

.grp-searchbox {
	position: relative;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
}

.develop-cards {
	position: relative;
	top: 70px;
	height: calc(100vh - 70px);
	padding: 15px 25px 20px 85px;
}

.page-heading .main-head {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
	position: relative;
	z-index: 1;
	margin-left: 12px;
}

.page-heading .main-head::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 27px;
	height: 20px;
	top: 3px;
	left: -11px;
	z-index: -1;
	background: #ffc145;
	border-radius: 50%;
}

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}

.sharemailbtns .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	color: #696969;
	background-color: #f4f4f4;
	border-color: #f4f4f4;

	width: 100%;
	text-align: start;
}

.sharemailbtns .btn-secondary {
	color: #696969;
	background-color: #ffffff;
	border-color: #ffffff;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.evaluatortag-modal-option-add {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	margin-top: 3px;
	padding: 10px;
	position: absolute;
	z-index: 7;
	width: 400px;
	font-size: var(--size-13);
	color: #545454;
}

.updatelinktext {
	font-size: 13px;
	color: #696969;
}

.grp-right-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 170px);
	overflow: hidden;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 30%;
}

.sharelink-right-content-container {
	height: calc(100vh - 280px);
	overflow: auto;
}

.slectedcandidate-table-container-seventy {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 170px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 70%;
}

.swp-reports-table thead tr {
	height: 50px;
	background: #e3e4e4;
	border-radius: 3px;
	vertical-align: middle;
	display: table;
	width: 100%;
	table-layout: fixed;
}

.swp-reports-table thead th {
	font-weight: 500 !important;
	font-size: 14px;
	color: #72738e;
}

.swp-reports-table thead th:last-child {
	padding-right: 15px;
}

.swp-reports-table tbody td {
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #696969;
	overflow: hidden;
	text-overflow: ellipsis;
}

.grouptable tbody {
	display: block;
	border-radius: 5px;
	overflow: auto;
	height: calc(100vh - 320px);
	margin-top: 5px;
	width: calc(100% - 5px);
}

.swp-reports-table tbody td:first-child {
	position: relative;
}

.swp-reports-table tbody td:last-child {
	padding-right: 20px;
}

.swp-reports-table tbody tr {
	height: 60px;
	cursor: pointer;
	box-sizing: border-box;
	box-shadow: 0px 4px 12px rgb(196 196 196 / 50%);
	margin: 10px 5px 8px 5px;
	width: calc(100% - 10px);
	display: table;
	border-radius: 3px;
	table-layout: fixed;
}

.paginaTion {
	min-width: 1002px;
	max-width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}

.shareppl-parentdiv {
	position: relative;
	height: calc(100vh - 90px);
	top: 80px;
	padding-left: 80px;
	overflow-x: hidden;
	padding-right: 15px;
}

.selected-table-cards:hover {
	background: #e7e8f5;
}

.selectedCandidateContainer {
	min-height: auto;
	max-height: calc(100vh - 560px);
	overflow-y: auto;
}

.groupshare-formtag {
	border: none;
	padding: 0px;
}

.groupshare-searchicon {
	position: absolute;
	top: 9px;
	left: 10px;
	margin-right: 2px;
}

.groupshare-seachinput {
	padding: 5px 10px 5px 30px !important;
}

.viewselectedCandidateContainer {
	height: 135px;
	overflow-y: auto;
}

.sharelink-elipsis {
	overflow: hidden;
	display: -webkit-box !important;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	white-space: normal;
	border: none;

	background: none !important;
}

.sharelink-elipsis-show {
	overflow: hidden;
	display: -webkit-box !important;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	white-space: normal;
	border: none;
	background: none !important;
}

.groupOptionsDivUpadte {
	min-height: auto;
	max-height: 200px;
	overflow-y: auto;
}

.groupOptionsDiv {
	overflow: auto;
	min-height: auto;
	max-height: 200px;
}

.groupOptionsDiv-2 {
	width: 100%;
	overflow-y: auto;
}

.sharepeople-filter-modal {
	position: absolute;
	width: 370px;
	height: 150px;
	top: 110px;
	right: 70px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.evaluator-tag-modal {
	position: absolute;
	width: 350px;
	height: 194px;
	top: 50px;
	right: 40px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.addtaginput {
	margin-left: -40px;
	margin-top: -2px;
}

.input-group > .form-control:focus {
	z-index: inherit;
}

.sharecandidates-container {
	background: #ededed;
	box-shadow: 0px 0px 4px rgb(0 0 0 / 25%);
	border-radius: 3px;
	padding: 11px 10px;
	margin-top: 10px;
}

.sharecandidates-container-body {
	background: #f9f9f9;
}

.cl-collapse {
	padding: unset;
}

.sharepeople-individual {
	text-decoration: underline;
	color: #396ad7;
	font-weight: 500;
	font-size: 14px;
}

.sharepeople-individual:hover {
	color: #1d47a0;
}

.disableLinkInput {
	background: none !important;
	color: #b9b7b7 !important;
}

.qb-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 0px;
}

.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
}

.margin-pgNo {
	margin-right: 250px;
}

.swp-group-detail-container {
	position: absolute;
	width: calc(100vw - 600px);
	height: calc(100vh - 75px);
	right: 5px;
	bottom: 0px;
	top: 2px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.slide-leave-active,
.slide-enter-active {
	transition: 0.5s;
}

.slide-enter {
	transform: translate(100%, 0);
}

.slide-leave-to {
	transform: translate(100%, 0);
}

.swp-group-detail-half-container {
	position: absolute;
	width: 450px;
	height: calc(100vh - 80px);
	right: 5px;
	top: 5px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.swp-left-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-Assessment-Link {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-view-Assessment-Link {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-Assessment-edit-Link {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	min-height: auto;
	max-height: 310px;
}

.swp-left-card-Assessment-group-edit-Link {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	min-height: calc(100vh - 745px);
}

.swp-left-card-height {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-height-ai {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	/* min-height: calc(100vh - 750px); */
}

.swp-left-card-height-select-g {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-height-create-g {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin: 3px;
}

.swp-left-card-height-create-gc {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin: 3px;
}

.swp-left-view-cand-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-view-individual-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-edit-individual-card {
	height: 640px;
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-candidates {
	min-height: auto;
	max-height: calc(100vh - 378px);
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-evaluators {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-left-card-evaluators-ei {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	min-height: auto;
}

.swp-main-text {
	font-weight: 600;
	font-size: 14px;
	color: #696969;
}

.swp-group-detail-footer {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 0px 0px 10px 10px;
	width: 100%;
}

.swp-detail-text {
	font-weight: 400;
	font-size: 10px;
	color: #72738e;
}

.swp-detail-text-1 {
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
}

.swp-detail-sub-text {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.swp-candidate-table {
	background: #ffffff;
	border: 1px solid #f4f4f4;
}

.swp-previous-link {
	font-weight: 500;
	font-size: 12px;
	color: #696969;
}

.swp-verticalDeviderLine {
	border: 0.5px solid #adaaaa;
	width: 600px;
	margin-top: 200px;
}

.swp-active-btn-text {
	font-weight: 500;
	font-size: 12px;
	color: #18a41d;
}

.swp-greyBackground {
	background: #f5f5f5;
	word-break: break-all;
}

.swp-jdTypeCheck:nth-child(odd) {
	background: #f4f4f4;
}

.swp-jdTypeCheck:nth-child(even) {
	background: #fdfdfd;
}

.swp-cancelbtntext {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 20px;
}

.swp-addbtn {
	background: #72738e !important;
	border: 1px solid #72738e !important;
	border-radius: 3px !important;
	font-weight: 500 !important;
	font-size: 13px !important;
	color: #ffffff !important;
	padding: 5px 20px !important;
}

.swp-twobtns {
	position: absolute;
	bottom: 0px;
	right: 0px;
}

.swp-checkboxcontainer {
	min-height: auto;
	max-height: 195px;
	overflow-y: auto;
}

.swp-cand-overflow {
	height: 385px;
	overflow: auto;
}

.swp-assessmentLink-vi-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 583px);
}

.swp-assessmentLink-view-overflow {
	min-height: auto;
	max-height: calc(100vh - 565px);
	overflow: auto;
}

.swp-edit-group-assessmentLink-overflow {
	min-height: auto;
	overflow: auto;
	max-height: calc(100vh - 585px);
}

.swp-view-email-overflow {
	overflow: auto;
	min-height: calc(100vh - 745px);
	max-height: calc(100vh - 370px);
}

.develop-cards .topDiv > .inputField {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	padding: 10px;
	border-radius: 3px !important;
	font-size: var(--size-16);
	font-weight: var(--weight-LM);
	z-index: 5;
	background: var(--bg-inputfield);
}

.swp-check-email {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}

.custom-control-label {
	cursor: pointer;

	/* styles for the second child element of .example */
}

.swp-share-link-text {
	font-weight: 400;
	font-size: 12px;
	text-decoration-line: underline;
	color: #696969;
}

.swp-update-link-text {
	font-weight: 500;
	font-size: 12px;
	text-decoration-line: underline;
	color: #72738e;
}

.swp-left-card-height-overflow {
	min-height: calc(100vh - 845px);
	max-height: calc(100vh - 455px);
	overflow: auto;
}

.swp-left-card-height-vi-overflow {
	min-height: auto;
	max-height: calc(100vh - 680px);
	overflow: auto;
}

.swp-left-card-height-gc-overflow {
	min-height: auto;
	max-height: calc(100vh - 680px);
	overflow: auto;
}

.swp-left-card-height-view-overflow {
	min-height: auto;
	max-height: calc(100vh - 595px);
	overflow: auto;
}

.swp-left-card-cng-eval-overflow {
	min-height: calc(100vh - 675px);
	max-height: calc(100vh - 680px);
	overflow: auto;
}

.swp-left-card-evaluator-overflow {
	min-height: auto;
	max-height: calc(100vh - 745px);
	overflow: auto;
}

.swp-activetext {
	font-weight: 500;
	font-size: 12px;
	color: #18a41d;
}

.swp-edit-group-select-evaluator-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 625px);
}

.swp-edit-group-evaluator-overflow {
	min-height: auto;
	max-height: calc(100vh - 565px);
	overflow: auto;
	padding-right: 10px;
}

.swp-yellownumbertext {
	font-weight: 500;
	font-size: 13px;
	color: #ffc145;
}

.swp-display-email-position {
	height: 500px;
	overflow: scroll;
}

.swp-textarea {
	background: #f5f5f5;
	min-height: 50px;
	max-height: auto;
	border-radius: 5px;
}

.swp-link-text {
	font-weight: 400;
	font-size: 12px;
	color: #5f6368;
}

.swp-inside-text {
	font-weight: 400;
	font-size: 14px;
	color: #6d6d6d;
}

.swp-qb-dropdown-option-add {
	background: #ffffff;
	border: 0.2px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;
	border-radius: 5px;
	margin-top: 0px;
	position: absolute;
	z-index: 7;
	width: 90%;
	font-size: var(--size-13);
	color: #545454;
	height: fit-content;
}

.swp-section-modal {
	position: absolute;
	width: 100%;
	top: 50px;
	right: 0px;
	background: #ffffff;
	border: 0.2px solid rgba(10, 86, 200, 0.5);
	border-radius: 5px;
	z-index: 5;
}

.swp-drop {
	border: 0.2px solid rgba(10, 86, 200, 0.5);
	padding: 8px !important;
}

.swp-section-text {
	background: var(--bg-white);
	position: absolute;
	font-size: var(--size-10);
	color: var(--btn-border);
	font-weight: var(--weight-LM);
	left: 12px;
	bottom: 28px;
	height: fit-content;
}

.swp-right-overflow {
	overflow: auto;
	height: calc(100vh - 250px);
}

.swp-right-view-group-overflow {
	overflow: auto;
	height: calc(100vh - 187px);
}

.swp-edit-individual-overflow {
	overflow: auto;
	max-height: calc(100vh - 295px);
	min-height: calc(100vh - 370px);
}

.swp-view-individual-overflow {
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 240px);
}
.error-txt-pos {
	position: absolute;
	top: 39px;
}
.swp-linkBackground {
	background: #f6f6fc;
	border: 0.7px solid #e5e5e5;
	border-radius: 5px;
}

/* .swp-addIndi_middle-container {
	height: calc(100vh - 490px);
	overflow: auto;
} */

.swp-create-group-sg-middle-container {
	height: calc(100vh - 291px);
}

.swp-group-detail-container .form-control.error:focus {
	border: 1px solid red !important;
}

.swp-group-detail-half-container .form-control.error:focus {
	border: 1px solid red !important;
}

.updateLink {
	font-size: 12px;
	line-height: 18px;
	text-decoration-line: underline;
	color: #72738e;
}

.generateLink {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 18px;
	text-decoration-line: underline;
	color: #72738e;
}

.swp-addconfig-background {
	background: #ebf5ff;
	border: 2px solid #84bae7;
	border-radius: 5px;
}

.swp-tagEval-modal {
	position: absolute;
	min-height: auto;
	max-height: 250px;
	overflow: auto;
	background: white;
	z-index: 1;
	border: 1px solid #ded9d9;
	border-radius: 0px 0px 3px 3px;
}

.swp-double-overflow {
	height: calc(100vh - 215px);
	overflow: auto;
}

.swp-left-card-height-vi {
	background: #313b04;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	min-height: calc(100vh - 700px);
}

.swp-left-card-cng-eval-cg-overflow {
	min-height: auto;
	max-height: calc(100vh - 680px);
	overflow: auto;
}

.swp-share-reshare-text {
	color: #6d6d6d;
}

.swp-trial-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.swp-trial-overflow {
	min-height: auto;
	max-height: 30px;
	overflow: auto;
}

.swp-blueborder .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 5px 32px 5px 5px;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	background-color: #fff;
	background-clip: padding-box;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	border-radius: 0.25rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.swp-eg {
	height: calc(100vh - 238px);
}

.swp-warning-box {
	background: #ffedc0;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	font-weight: var(--weight-R);
	font-size: var(--size-14);
	color: #72738e;
	padding: 9px 15px;
}
.swp-double-overflow
	.custom-radio.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-radio .custom-control-label::before {
	top: 2px;
	left: -1.3125rem;
	width: 15px;
	height: 15px;
	border-radius: 50%;
}
.swp-double-overflow
	.custom-radio.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-radio .custom-control-label::after {
	top: 2px;
	left: -1.3125rem;
	width: 15px;
	height: 15px;
	border-radius: 50%;
}
.noSearchResultsText {
	margin-top: 2px;
	display: flex;
	justify-content: center;
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-size: var(--size-14);
	color: #212529;
}

.section-content-group {
	padding: 8px;
	background: #ffffff;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;
	border-radius: 3px;
}

.grp-tab {
	color: #72738e;
	font-size: 14px;
	font-weight: 500;
	background-color: #ececec;
	height: 37px;
	width: 200px;
	border-radius: 2px;
}

.grp-slant {
	right: -18px;
	position: absolute;
	width: 40px;
	height: 37px;
	background-color: #ececec;
	transform: skew(40deg);
}

.grp-tab-sel {
	color: #fff;
	font-size: 14px;
	font-weight: 500;
	background-color: #72738e;
	height: 37px;
	width: 200px;
	border-radius: 2px;
}
.grp-slant-sel {
	right: -18px;
	position: absolute;
	width: 40px;
	height: 37px;
	background-color: #72738e;
	transform: skew(40deg);
}

.grp-mr {
	margin-right: 32px;
}

/* table new design starts from here */
.shareWithPeople-table-container {
	background: #ffffff;
	border-radius: 8px;
	padding: 15px 5px;
	min-width: 1230px;
	max-width: 100%;
	height: calc(100vh - 170px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	overflow: auto;
	width: 100%;
}
.shareWithPeople-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 251px);
	overflow-x: auto;
	overflow-y: hidden;
}

.shareWithPeople-table-head {
	min-width: 1000px;
	max-width: 100%;
	background: #e3e4e4;
	border-radius: 3px;
	display: flex;
	align-items: center;
	padding: 10px 0px;
	font-weight: 500 !important;
	font-size: 14px;
	color: #72738e;
}

.shareWithPeople-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 345px);
}

.shareWithPeople-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 2px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 8px 0px;
}

.shareWithPeople-table-row:hover {
	background: #e7e8f5;
}

.shareWithPeople-changecolor-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	background: #ebf5fe;
	border: 2px solid #84bae7;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 8px 0px;
}

.mt-30 {
	margin-top: 30px;
}
.right-container-head {
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: 13px;
	color: #3a3c40;
}

.right-container-subhead {
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #3a3c40;
}
.tooltip-wrapper {
	position: relative;
}

.price-tooltip {
	position: absolute;
	top: 28px;
	left: -45px;
	width: 220px;
	padding: 12px;
	opacity: 0;
	visibility: hidden;
	transition: 0.2s ease;
	z-index: 10;
	background: #d9d9d9;
	border-radius: 8.00411px;
}

.tooltip-wrapper:hover .price-tooltip {
	opacity: 1;
	visibility: visible;
}

.tooltip-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 6px;
}
.price-tooltip::before {
	content: "";
	position: absolute;
	top: -8px;
	left: 50%;
	transform: translateX(-50%);
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-bottom: 8px solid #d9d9d9;
}
</style>
